module.exports = {
    "areg": {
        "<%=userName%>坐着<%=carName%>进入了直播间": "<%=userName%> يقود <%=carName%> لدخول غرفة البث المباشر",
        "AD": "أندورا",
        "AE": "الإمارات العربية المتحدة",
        "AF": "أفغانستان",
        "AG": "أنتيغوا وبربودا",
        "AI": "أنغيلا",
        "AL": "ألبانيا",
        "AM": "أرمينيا",
        "AN": "جزر الأنتيل الهولندية",
        "AO": "أنغولا",
        "AQ": "القطب الجنوبي",
        "AR": "الأرجنتين",
        "AS": "ساموا الأمريكية",
        "AT": "النمسا",
        "AU": "أستراليا",
        "AW": "أروبا",
        "AZ": "أذربيجان",
        "BA": "البوسنة والهرسك",
        "BB": "بربادوس",
        "BD": "بنغلاديش",
        "BE": "بلجيكا",
        "BF": "بوركينا فاسو",
        "BG": "بلغاريا",
        "BH": "البحرين",
        "BI": "بوروندي",
        "BJ": "بنين",
        "BL": "سانت بارتيليمي",
        "BM": "برمودا",
        "BN": "بروناي",
        "BO": "بوليفيا",
        "BR": "البرازيل",
        "BS": "الباهاما",
        "BT": "بوتان",
        "BW": "بوتسوانا",
        "BY": "روسيا البيضاء",
        "BZ": "بليز",
        "CA": "كندا",
        "CC": "جزر كوكوس",
        "CD": "جمهورية الكونغو الديموقراطية",
        "CF": "جمهورية افريقيا الوسطى",
        "CG": "جمهورية الكونغو",
        "CH": "سويسرا",
        "CI": "ساحل العاج",
        "CK": "جزر كوك",
        "CL": "تشيلي",
        "CM": "الكاميرون",
        "CN": "الصين",
        "CO": "كولومبيا",
        "CR": "كوستا ريكا",
        "CU": "كوبا",
        "CV": "الرأس الأخضر",
        "CW": "كوراكاو",
        "CX": "جزيرة عيد الميلاد",
        "CY": "قبرص",
        "CZ": "جمهورية التشيك",
        "DE": "ألمانيا",
        "DJ": "جيبوتي",
        "DK": "الدنمارك",
        "DM": "دومينيكا",
        "DO": "جمهورية الدومنيكان",
        "DZ": "الجزائر",
        "EC": "الإكوادور",
        "EE": "استونيا",
        "EG": "مصر",
        "EH": "الصحراء الغربية",
        "ER": "إريتريا",
        "ES": "إسبانيا",
        "ET": "أثيوبيا",
        "FI": "فنلندا",
        "FJ": "فيجي",
        "FK": "جزر فوكلاند",
        "FM": "ميكرونيزيا",
        "FO": "جزر صناعية",
        "FR": "فرنسا",
        "GA": "الغابون",
        "GB": "المملكة المتحدة",
        "GD": "غرينادا",
        "GE": "جورجيا",
        "GG": "غيرنسي",
        "GH": "غانا",
        "GI": "جبل طارق",
        "GL": "الأرض الخضراء",
        "GM": "غامبيا",
        "GN": "غينيا",
        "GQ": "غينيا الإستوائية",
        "GR": "اليونان",
        "GT": "غواتيمالا",
        "GU": "غوام",
        "GW": "غينيا بيساو",
        "GY": "غيانا",
        "HK": "هونغ كونغ",
        "HN": "هندوراس",
        "HR": "كرواتيا",
        "HT": "هايتي",
        "HU": "هنغاريا",
        "ID": "أندونيسيا",
        "IE": "أيرلندا",
        "IL": "إسرائيل",
        "IM": "جزيرة آيل أوف مان",
        "IN": "الهند",
        "IO": "إقليم المحيط البريطاني الهندي",
        "IQ": "العراق",
        "IR": "إيران",
        "IS": "أيسلندا",
        "IT": "إيطاليا",
        "JE": "جيرسي",
        "JM": "جامايكا",
        "JO": "الأردن",
        "JP": "اليابان",
        "KE": "كينيا",
        "KG": "قرغيزستان",
        "KH": "كمبوديا",
        "KI": "كيريباس",
        "KM": "جزر القمر",
        "KN": "سانت كيتس ونيفيس",
        "KP": "كوريا الشمالية",
        "KR": "كوريا الجنوبية",
        "KW": "الكويت",
        "KY": "جزر كايمان",
        "KZ": "كازاخستان",
        "LA": "لاوس",
        "LB": "لبنان",
        "LC": "سانت لوسيا",
        "LI": "ليختنشتاين",
        "LK": "سيريلانكا",
        "LR": "ليبيريا",
        "LS": "ليسوتو",
        "LT": "ليتوانيا",
        "LU": "لوكسمبورغ",
        "LV": "لاتفيا",
        "LY": "ليبيا",
        "MA": "المغرب",
        "MC": "موناكو",
        "MD": "مولدوفا",
        "ME": "الجبل الأسود",
        "MF": "سانت مارتن",
        "MG": "مدغشقر",
        "MH": "جزر مارشال",
        "MK": "مقدونيا",
        "ML": "مالي",
        "MM": "ميانمار",
        "MN": "منغوليا",
        "MO": "ماكاو",
        "MP": "جزر مريانا الشمالية",
        "MR": "موريتانيا",
        "MS": "مونتسيرات",
        "MT": "مالطا",
        "MU": "موريشيوس",
        "MV": "جزر المالديف",
        "MW": "ملاوي",
        "MX": "المكسيك",
        "MY": "ماليزيا",
        "MZ": "موزمبيق",
        "NA": "ناميبيا",
        "NC": "كاليدونيا الجديدة",
        "NE": "النيجر",
        "NG": "نيجيريا",
        "NI": "نيكاراغوا",
        "NL": "هولندا",
        "NO": "النرويج",
        "NP": "نيبال",
        "NR": "ناورو",
        "NU": "نيوي",
        "NZ": "نيوزيلاندا",
        "OM": "سلطنة عمان",
        "PA": "بناما",
        "PE": "بيرو",
        "PF": "بولينيزيا الفرنسية",
        "PG": "بابوا غينيا الجديدة",
        "PH": "الفلبين",
        "PK": "باكستان",
        "PL": "بولندا",
        "PM": "سان بيار وميكلون",
        "PN": "بيتكيرن",
        "PR": "بورتوريكو",
        "PS": "فلسطين",
        "PT": "البرتغال",
        "PW": "بالاو",
        "PY": "باراغواي",
        "QA": "قطر",
        "RE": "جمع شمل",
        "RO": "رومانيا",
        "RS": "صربيا",
        "RU": "روسيا",
        "RW": "رواندا",
        "SA": "المملكة العربية السعودية",
        "SB": "جزر سليمان",
        "SC": "سيشيل",
        "SD": "سودان",
        "SE": "السويد",
        "SG": "سنغافورة",
        "SH": "سانت هيلانة",
        "SI": "سلوفينيا",
        "SJ": "سفالبارد وجان مايان",
        "SK": "سلوفاكيا",
        "SL": "سيرا ليون",
        "SM": "سان مارينو",
        "SN": "السنغال",
        "SO": "الصومال",
        "SR": "سورينام",
        "SS": "جنوب السودان",
        "ST": "ساو تومي وبرينسيبي",
        "SV": "السلفادور",
        "SX": "سانت مارتن",
        "SY": "سوريا",
        "SZ": "سوازيلاند",
        "TC": "جزر تركس وكايكوس",
        "TD": "تشاد",
        "TG": "توغو",
        "TH": "تايلاند",
        "TJ": "طاجيكستان",
        "TK": "توكيلاو",
        "TL": "تيمور الشرقية",
        "TM": "تركمانستان",
        "TN": "تونس",
        "TO": "تونغا",
        "TR": "تركيا",
        "TT": "ترينداد وتوباغو",
        "TV": "توفالو",
        "TW": "تايوان",
        "TZ": "تنزانيا",
        "UA": "أوكرانيا",
        "UG": "أوغندا",
        "US": "الولايات المتحدة",
        "UY": "أوروغواي",
        "UZ": "أوزبكستان",
        "Up号:<%=code%>": "رقم حساب: <%=code%>",
        "Up直播": "uplive ",
        "U币贡献榜": "قائمة الأكثر دعما لمُضيف",
        "VA": "الفاتيكان",
        "VC": "سانت فنسنت وجزر غرينادين",
        "VE": "فنزويلا",
        "VG": "جزر فيرجن البريطانية",
        "VI": "جزر العذراء الأمريكية",
        "VN": "فيتنام",
        "VU": "فانواتو",
        "WF": "واليس وفوتونا",
        "WS": "ساموا",
        "XK": "كوسوفو",
        "YE": "اليمن",
        "YT": "مايوت",
        "ZA": "جنوب أفريقيا",
        "ZM": "زامبيا",
        "ZW": "زيمبابوي",
        "个人信息设定失败": "فشل في تحديد البيانات الشخصية",
        "个人信息设定成功": "تم تحديد البيانات الشخصية بنجاح",
        "主播可能在休息，稍后再来试试吧": "الآن هو وقت استراحه المُضيف، الرجاء الانتظار قليلا ثم العوده إليه",
        "主播已停播，即将返回首页!": "لقد أنهى المضيف البث المباشر، الرجوع إلى الصفحة الرئيسية",
        "优秀主播指南": "دليل المُضيفين المميزين",
        "余额不足情况下，充值提醒的描述": "الرصيد الماس غير كافى، أشحن الآن",
        "你关注的人还没有直播": "مُضيفك المفضل غير موجود الآن",
        "保存": "حفظ",
        "充值 >": "الشحن",
        "关注": "متابعة",
        "关注了主播，从此不再错过。": "قُم بمتابعة المُضيف الآن، ولا تفوت أي لحظة معه",
        "写个签名吧，让大家了解你。": "اكتب نبذة عنك، لكى يتمكن الجميع من معرفتك أكثر",
        "分享失败": "فشل المشاركة",
        "分享成功": "تمت المشاركة بنجاح",
        "去看看当前热门直播": "الرجوع الى صفحة قائمة الشائع",
        "参数无效": "كود غير صالح",
        "参数错误": "خطأ في الكود",
        "发现": "اكتشف",
        "发现新主播": "اكتشف المُضيفين الجدد",
        "发送": "أرسل",
        "取消": "إلغاء",
        "如何升级": "كيف يتم الترقي",
        "如何升级详情": " عند إهداء المُضيفين هدايا أكثر، يتم ترقيتهم أسرع.@@@@  ما رأيك أن تصبح مُضيف؟ المُضيفون المُتميزون يتم ترقيتهم أسرع",
        "守护身价:<%=code%>": "سعر منصب الحارس: <%=code%>",
        "已停播": "لقد توقف البث المباشر",
        "已关注": "تمت المتابعة ",
        "已取消分享": "تم إلغاء المشاركة",
        "我的U钻": "الماس ",
        "我的守护": "الحارس ",
        "我的收益（U币）": "إيراداتى من (الكوينز)",
        "我的直播": "البث المباشر الخاص بى",
        "我的等级": "المستوى",
        "拉黑": "حظر",
        "按语言推荐主播": "إقتراح مُضيفين بناءًا على اللغة",
        "搜索": "بحث",
        "收到的U币": "الكوينز التى تم الحصول عليها",
        "昵称不能出现敏感词": "لا يُمكن استخدام أي كلمات خارجة في الاسم",
        "暂无数据": "لا توجد بيانات متوفرة مؤقتًا",
        "暂无被拉黑用户": "لا يوجد معلومات متوفرة في القائمة السوداء مؤقتًا",
        "未知星球": "غير معروف",
        "正在加载": "جارٍ التحميل",
        "正在加载更多的数据...": "جارٍ تحميل المزيد من البيانات",
        "没发现此人，请重新输入试试": "لم تقم باكتشاف أي أحد، يُرجى المحاولة مرة أُخرى",
        "没有更多数据了哦": "لا يوجد مزيد من البيانات",
        "点亮了": "أحب هذه البث ",
        "热门": "الشائع",
        "用户登录失效": "فشل تسجيل دخول المُستخدم",
        "登出": "تسجيل الخروج",
        "直播中": "مباشر الآن",
        "确认": "تأكيد",
        "等级福利": "إمتيازات هذا المستوى ",
        "等级福利详情": " المستخدمون ذو المستوى المرتفع لديهم شعار مميز لنبذتهم الشخصية.@@@@  عند ترقيتك في المستوى، لديك فرص أكثر في الحصول على هدايا قيمة.",
        "签名不能出现敏感词": "لا يُمكن استخدام أي كلمات خارجة في الاسم",
        "粉丝": "معجبون",
        "系统消息": "رسالة النظام",
        "系统消息: 主播回来了，视频即将恢复！": "رسالة النظام: لقد عاد المُضيف، سيعود البث المباشر الآن",
        "系统消息: 主播暂时离开了，小伙伴们请稍候。": "رسالة النظام: لقد غادر المُضيف مؤقتا، من فضلك انتظر قليلا ",
        "系统消息: 我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。": "رسالة النظام: نحن ندعم دائما البث المباشر المميز، والمُضيف المميز يظهر على قائمة الشائع مع الأشارة التى تميزه.\nإذا كان الصورة الشخصية الخاصة بالمُضيف أو المحتوى الخاص بالبث يحتوى على أى إيحاءات جنسية أو صور إباحية أو تدخين و مخدرات أو عنف و غيرها من الحالات الأخرى، سيتم وقف البث المباشر فى الحال.\nيتم مراقبة البث المباشر على مدار الـ24 ساعة ،  ونرجو منكم الإلتزام",
        "系统错误": "خطأ فى النظام",
        "累计经验：<%=code%>": "مجموع نقاط الخبرة：<%=code%>",
        "经验值<%=num%>": "نقاط الخبرة <%=num%>",
        "花费:": "تم إنفاق: ",
        "获取个人信息失败": "فشل في الحصول على المعلومات الشخصية",
        "获取成功": "تم الحصول عليه بنجاح",
        "获取热门主播失败": "فشل فى الحصول على قائمة الشائع",
        "虚位以待": "المركز لم يشغله أحد",
        "解除拉黑": "إزالة الحظر",
        "设置国家或地区失败": "فشل في تحديد الدولة أو المنطقة",
        "设置国家或地区成功": "تم تحديد الدولة أو المنطقة بنجاح",
        "说点什么吧": "دردش الآن",
        "请竖屏获得更佳体验": "يُرجى أن تكون الشاشة في وضع عمودي، للحصول على تجربة أفضل",
        "请输入用户昵称或Up号": "من فضلك قُم بإدخال الاسم أو رقم الحساب",
        "贡献U币:<%=code%>": " الكوينز التي تم الدعم بها: <%=code%>",
        "赠送": "أرسل هدية",
        "赠送了<%=count%>个<%=giftName%>": " أرسل <%=count%> من <%=giftName%>",
        "赠送了<%=giftName%>": "أرسل <%=giftName%>",
        "距离下一级：<%=code%>": "باقى على المستوى التالى：<%=code%>",
        "进入房间失败": "فشل فى دخول غرفة البث المباشر",
        "进入房间超时": "انتهاء مهلة دخول غرفة البث المباشر",
        "连": "+1",
        "连接失败，请退出直播间重新进入": "فشل فى الإتصال، من فضلك اخرج من غرفة البث المباشر وأعد الدخول مرة أخرى",
        "选择国家或地区": "قُم باختيار الدولة أو المنطقة",
        "重新选择": "إعادة الاختيار",
        "黑名单": "القائمة السوداء"
    },
    "enus": {
        "<%=userName%>坐着<%=carName%>进入了直播间": "Welcome <%=userName%> enter the chatting room on <%=carName%> ",
        "AD": "Andorra",
        "AE": "United Arab Emirates",
        "AF": "Afghanistan",
        "AG": "Antigua and Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Netherlands Antilles",
        "AO": "Angola",
        "AQ": "Antarctica",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia and Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Cocos Islands",
        "CD": "Democratic Republic of the Congo",
        "CF": "Central African Republic",
        "CG": "Republic of the Congo",
        "CH": "Switzerland",
        "CI": "Ivory Coast",
        "CK": "Cook Islands",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Christmas Islands",
        "CY": "Cyprus",
        "CZ": "Czech Republic",
        "DE": "Germany",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Dominican Republic",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Egypt",
        "EH": "Western Sahara",
        "ER": "Eritrea",
        "ES": "Spain",
        "ET": "Ethiopia",
        "FI": "Finland",
        "FJ": "Fiji",
        "FK": "Falkland Islands",
        "FM": "Micronesia",
        "FO": "Faroe Islands",
        "FR": "France",
        "GA": "Gabon",
        "GB": "United Kingdom",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Equatorial Guinea",
        "GR": "Greece",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "British Indian Ocean Territory",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Italy",
        "JE": "Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Japan",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Cambodia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts and Nevis",
        "KP": "North Korea",
        "KR": "South Korea",
        "KW": "Kuwait",
        "KY": "Cayman Islands",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Marshall Islands",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "Macau",
        "MP": "Northern Mariana Islands",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Netherlands",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Poland",
        "PM": "Saint Pierre and Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestine",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Russia",
        "RW": "Rwanda",
        "SA": "Saudi Arabia",
        "SB": "Solomon Islands",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapore",
        "SH": "Saint Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard and Jan Mayen",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "South Sudan",
        "ST": "Sao Tome and Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TC": "Turks and Caicos Islands",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "East Timor",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad and Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraine",
        "UG": "Uganda",
        "US": "United States",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "Up号:<%=code%>": "Up ID:<%=code%>",
        "Up直播": "UpLive",
        "U币贡献榜": "Top fans",
        "VA": "Vatican",
        "VC": "Saint Vincent and the Grenadines",
        "VE": "Venezuela",
        "VG": "British Virgin Islands",
        "VI": "U.S. Virgin Islands",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis and Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "South Africa",
        "ZM": "Zambia",
        "ZW": "Zimbabwe",
        "个人信息设定失败": "Fail to save",
        "个人信息设定成功": "Saved success",
        "主播可能在休息，稍后再来试试吧": "The host is having a rest, please check later",
        "主播已停播，即将返回首页!": "Live stream ended, go back to homepage instantly",
        "优秀主播指南": "Broadcaster Guidelines",
        "余额不足情况下，充值提醒的描述": "Insufficient balance, want to go recharge?",
        "你关注的人还没有直播": "None of your followings is boardcasting.",
        "保存": "Save",
        "充值 >": "Recharge >",
        "关注": "Following",
        "关注了主播，从此不再错过。": "followed this host",
        "写个签名吧，让大家了解你。": "Say something about yourself",
        "分享失败": "Share failed",
        "分享成功": "Share successful",
        "去看看当前热门直播": "Go to check the hot list",
        "参数无效": "Invalid parameters",
        "参数错误": "error",
        "发现": "Discover",
        "发现新主播": "Discover interesting host",
        "发送": "Send",
        "取消": "Cancel",
        "如何升级": "How do I level up?",
        "如何升级详情": "Send more points and gain even more points.@@@@ Try to start your own boardcasts! ",
        "守护身价:<%=code%>": "Guardian Price",
        "已停播": "Live stream ended",
        "已关注": "Followed",
        "已取消分享": "Cancel",
        "我的U钻": "My U diamonds",
        "我的守护": "My Guardian",
        "我的收益（U币）": "My U coins (earnings)",
        "我的直播": "My shows",
        "我的等级": "My level",
        "拉黑": "Add to block list",
        "按语言推荐主播": "Recommended by language",
        "搜索": "Search",
        "收到的U币": "U coins earned",
        "昵称不能出现敏感词": "This nick name includs prohibit word",
        "暂无数据": "No data",
        "暂无被拉黑用户": "Noboby on the blacklist",
        "未知星球": "Unknown location",
        "正在加载": "Loading",
        "正在加载更多的数据...": "Loading more data...",
        "没发现此人，请重新输入试试": "No result found",
        "没有更多数据了哦": "That's all",
        "点亮了": "liked this",
        "热门": "Hot",
        "用户登录失效": "Sign-in failed",
        "登出": "Logout",
        "直播中": "On air",
        "确认": "Confirm",
        "等级福利": "My rewards",
        "等级福利详情": "Your level is represented by this distinguish icon. The higher levels have more chance to enjoy tailored benefits.",
        "签名不能出现敏感词": "Introduction includs prohibit word",
        "粉丝": "Fans",
        "系统消息": "System message:",
        "系统消息: 主播回来了，视频即将恢复！": "System message: host is coming back! The show is about is begin!",
        "系统消息: 主播暂时离开了，小伙伴们请稍候。": "System message: host left for a moment, please be patient for a while.",
        "系统消息: 我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。": "Content relating to violence, smoking, drugs or pornography is strictly prohibited. Administrators will be patrolling 24/7 and any users found with such content will be banned.",
        "系统错误": "System error",
        "累计经验：<%=code%>": "Epx. accumulated: <%=code%>",
        "经验值<%=num%>": "<%=num%> Exp",
        "花费:": "Contribute",
        "获取个人信息失败": "Fail to get your personal information",
        "获取热门主播失败": "Fail to acquire the hot list",
        "虚位以待": "Waiting for someon...",
        "解除拉黑": "Remove from bloack list",
        "设置国家或地区失败": "Fail to set your country / region",
        "设置国家或地区成功": "Country/Region information updated!",
        "说点什么吧": "Say something",
        "请竖屏获得更佳体验": "Keep your screen vertical to get a better experience",
        "请输入用户昵称或Up号": "Enter nickname or Up ID",
        "贡献U币:<%=code%>": "U coins contributed: <%=code%>",
        "赠送": "Gift",
        "赠送了<%=count%>个<%=giftName%>": "sent <%=count%> <%=giftName%>",
        "赠送了<%=giftName%>": "Sent <%=giftName%>",
        "距离下一级：<%=code%>": "To next level: <%=code%> ",
        "进入房间失败": "Fail to enter this room",
        "进入房间超时": "Timeout",
        "连": "+1",
        "连接失败，请退出直播间重新进入": "Connection failed, try to quit and enter again.",
        "选择国家或地区": "Choose your country/region",
        "重新选择": "Choose again",
        "黑名单": "Blasklist"
    },
    "eses": {
        "AD": "Andorra",
        "AE": "Emiratos Árabes Unidos",
        "AF": "Afganistán",
        "AG": "Antigua y Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Antillas holandesas",
        "AO": "Angola",
        "AQ": "Antártida",
        "AR": "Argentina",
        "AS": "Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaiyán",
        "BA": "Bosnia y Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Bélgica",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrein",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "San Bartolomé",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brasil",
        "BS": "Bahamas",
        "BT": "Bhután",
        "BW": "Botswana",
        "BY": "Belarús",
        "BZ": "Belice",
        "CA": "Canadá",
        "CC": "Islas Cocos",
        "CD": "República Democrática del Congo",
        "CF": "República Centroafricana",
        "CG": "República Democrática del Congo",
        "CH": "Suiza",
        "CI": "Costa de marfil",
        "CK": "Islas Cook",
        "CL": "Chile",
        "CM": "Camerún",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cabo Verde",
        "CW": "Curacao",
        "CX": "Islas de Navidad",
        "CY": "Chipre",
        "CZ": "República Checa",
        "DE": "Alemania",
        "DJ": "Djibouti",
        "DK": "Dinamarca",
        "DM": "dominica",
        "DO": "República Dominicana",
        "DZ": "Argelia",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Egipto",
        "EH": "Sahara occidental",
        "ER": "Eritrea",
        "ES": "España",
        "ET": "Etiopía",
        "FI": "Finlandia",
        "FJ": "Fiji",
        "FK": "islas Malvinas",
        "FM": "Micronesia",
        "FO": "Islas Feroe",
        "FR": "Francia",
        "GA": "Gabón",
        "GB": "Inglés",
        "GD": "Granada",
        "GE": "Georgia",
        "GG": "Guernesey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Groenlandia",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Guinea Ecuatorial",
        "GR": "Grecia",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guayana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croacia",
        "HT": "Haití",
        "HU": "Hungría",
        "ID": "Indonesia",
        "IE": "Irlanda",
        "IL": "Israel",
        "IM": "Isla de Man",
        "IN": "India",
        "IO": "Territorio Británico del Océano Índico",
        "IQ": "Irak",
        "IR": "Irán",
        "IS": "Islandia",
        "IT": "Italia",
        "JE": "New Jersey",
        "JM": "Jamaica",
        "JO": "Jordania",
        "JP": "Japón",
        "KE": "Kenia",
        "KG": "Kirguistán",
        "KH": "Camboya",
        "KI": "Kiribati",
        "KM": "Comoras",
        "KN": "San Cristóbal y Nieves",
        "KP": "Corea del Norte",
        "KR": "Corea",
        "KW": "Kuwait",
        "KY": "Islas Caimán",
        "KZ": "Kazajstán",
        "LA": "Laos",
        "LB": "Líbano",
        "LC": "Santa Lucía",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesoto",
        "LT": "Lituania",
        "LU": "Luxemburgo",
        "LV": "Letonia",
        "LY": "Libia",
        "MA": "Marruecos",
        "MC": "Mónaco",
        "MD": "Moldavia",
        "ME": "Montenegro",
        "MF": "San Martín",
        "MG": "Madagascar",
        "MH": "Islas Marshall",
        "MK": "macedonia",
        "ML": "mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "macao",
        "MP": "Islas Marianas del Norte",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauricio",
        "MV": "Maldivas",
        "MW": "Malawi",
        "MX": "México",
        "MY": "Malasia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "nueva Caledonia",
        "NE": "Níger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Países Bajos",
        "NO": "Noruega",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "Nueva Zelandia",
        "OM": "Omán",
        "PA": "Panamá",
        "PE": "Perú",
        "PF": "Polinesia francés",
        "PG": "Papua Nueva Guinea",
        "PH": "Filipinas",
        "PK": "Pakistán",
        "PL": "Polonia",
        "PM": "San Pedro y Miquelón",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestina",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Katar",
        "RE": "reunión",
        "RO": "Rumania",
        "RS": "Serbia",
        "RU": "Rusia",
        "RW": "Ruanda",
        "SA": "Arabia Saudita",
        "SB": "islas Salomón",
        "SC": "Seychelles",
        "SD": "Sudán",
        "SE": "Suecia",
        "SG": "Singapur",
        "SH": "St. Helena",
        "SI": "Eslovenia",
        "SJ": "Svalbard",
        "SK": "Eslovaquia",
        "SL": "Sierra Leona",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Surinam",
        "SS": "Sudán del Sur",
        "ST": "Santo Tomé y Príncipe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Siria",
        "SZ": "Swazilandia",
        "TC": "Turks y Caicos",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Tailandia",
        "TJ": "Tayikistán",
        "TK": "Tokelau",
        "TL": "Timor del Este",
        "TM": "Turkmenistán",
        "TN": "Túnez",
        "TO": "Tonga",
        "TR": "Turquía",
        "TT": "Trinidad y Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwán",
        "TZ": "Tanzania",
        "UA": "Ucrania",
        "UG": "Uganda",
        "US": "Estados Unidos",
        "UY": "Uruguay",
        "UZ": "Uzbekistán",
        "VA": "Santa Sede",
        "VC": "San Vicente y las Granadinas",
        "VE": "Venezuela",
        "VG": "Islas Vírgenes Británicas",
        "VI": "Islas Vírgenes de los Estados",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis y Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "Sudáfrica",
        "ZM": "Zambia",
        "ZW": "Zimbabue"
    },
    "frfr": {
        "AD": "Andorre",
        "AE": "Emirats Arabes Unis",
        "AF": "Afghanistan",
        "AG": "Antigua-et-Barbuda",
        "AI": "Anguilla",
        "AL": "Albanie",
        "AM": "Arménie",
        "AN": "Antilles néerlandaises",
        "AO": "Angola",
        "AQ": "Antarctique",
        "AR": "Argentine",
        "AS": "Samoa Américaines",
        "AT": "Autriche",
        "AU": "Australie",
        "AW": "Aruba",
        "AZ": "Azerbaïdjan",
        "BA": "Bosnie Herzégovine",
        "BB": "Barbade",
        "BD": "Bangladesh",
        "BE": "Belgique",
        "BF": "Burkina Faso",
        "BG": "Bulgarie",
        "BH": "Bahreïn",
        "BI": "Burundi",
        "BJ": "Bénin",
        "BL": "Saint-Barthélemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivie",
        "BR": "Brésil",
        "BS": "Bahamas",
        "BT": "Bhoutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Îles Cocos",
        "CD": "République Démocratique du Congo",
        "CF": "République centrafricaine",
        "CG": "République du Congo",
        "CH": "Suisse",
        "CI": "Côte d'Ivoire",
        "CK": "les Îles Cook",
        "CL": "Chili",
        "CM": "Cameroun",
        "CN": "Chine",
        "CO": "Colombie",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cap-Vert",
        "CW": "Curacao",
        "CX": "Christmas Islands",
        "CY": "Chypre",
        "CZ": "République Tchèque",
        "DE": "Allemagne",
        "DJ": "Djibouti",
        "DK": "Danemark",
        "DM": "Dominique",
        "DO": "République Dominicaine",
        "DZ": "Algérie",
        "EC": "Equateur",
        "EE": "Estonie",
        "EG": "Egypte",
        "EH": "Sahara occidental",
        "ER": "Érythrée",
        "ES": "l'Espagne",
        "ET": "Ethiopie",
        "FI": "Finlande",
        "FJ": "Fidji",
        "FK": "les îles Falkland",
        "FM": "Micronésie",
        "FO": "Îles Féroé",
        "FR": "France",
        "GA": "Gabon",
        "GB": "Royaume-Uni",
        "GD": "Grenade",
        "GE": "Géorgie",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Groenland",
        "GM": "Gambie",
        "GN": "Guinée",
        "GQ": "Guinée Équatoriale",
        "GR": "Grèce",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinée-Bissau",
        "GY": "Guyane",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croatie",
        "HT": "Haïti",
        "HU": "Hongrie",
        "ID": "Indonésie",
        "IE": "Irlande",
        "IL": "Israël",
        "IM": "Isle of Man",
        "IN": "Inde",
        "IO": "Territoire britannique de l'océan Indien",
        "IQ": "Irak",
        "IR": "l'Iran",
        "IS": "Islande",
        "IT": "Italie",
        "JE": "Jersey",
        "JM": "Jamaïque",
        "JO": "Jordanie",
        "JP": "Japon",
        "KE": "Kenya",
        "KG": "Kirghizistan",
        "KH": "Cambodge",
        "KI": "Kiribati",
        "KM": "Comores",
        "KN": "Saint-Christophe-et-Niévès",
        "KP": "Corée du Nord",
        "KR": "Corée du Sud",
        "KW": "Koweit",
        "KY": "Îles Caïmans",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Liban",
        "LC": "Sainte-Lucie",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Libéria",
        "LS": "Lesotho",
        "LT": "Lituanie",
        "LU": "Luxembourg",
        "LV": "Lettonie",
        "LY": "Libye",
        "MA": "Maroc",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Monténégro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Iles Marshall",
        "MK": "Macédoine",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongolie",
        "MO": "Macau",
        "MP": "Îles Mariannes du Nord",
        "MR": "Mauritanie",
        "MS": "Montserrat",
        "MT": "Malte",
        "MU": "Ile Maurice",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexique",
        "MY": "Malaisie",
        "MZ": "Mozambique",
        "NA": "Namibie",
        "NC": "Nouvelle Calédonie",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Pays-Bas",
        "NO": "Norvège",
        "NP": "Népal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "nouvelle Zélande",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Pérou",
        "PF": "Polynésie française",
        "PG": "Papouasie Nouvelle Guinée",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Pologne",
        "PM": "Saint-Pierre-et-Miquelon",
        "PN": "Pitcairn",
        "PR": "Porto Rico",
        "PS": "Palestine",
        "PT": "le Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Réunion",
        "RO": "Roumanie",
        "RS": "Serbie",
        "RU": "Russie",
        "RW": "Rwanda",
        "SA": "Arabie Saoudite",
        "SB": "Les îles Salomon",
        "SC": "les Seychelles",
        "SD": "Soudan",
        "SE": "Suède",
        "SG": "Singapour",
        "SH": "Saint Helena",
        "SI": "Slovénie",
        "SJ": "Svalbard et Jan Mayen",
        "SK": "Slovaquie",
        "SL": "Sierra Leone",
        "SM": "Saint Marin",
        "SN": "Sénégal",
        "SO": "Somalie",
        "SR": "Suriname",
        "SS": "Soudan du sud",
        "ST": "Sao Tomé-et-Principe",
        "SV": "Le Salvador",
        "SX": "Sint Maarten",
        "SY": "Syrie",
        "SZ": "Swaziland",
        "TC": "îles Turques-et-Caïques",
        "TD": "Tchad",
        "TG": "Aller",
        "TH": "Thaïlande",
        "TJ": "Tadjikistan",
        "TK": "Tokelau",
        "TL": "Timor oriental",
        "TM": "Turkménistan",
        "TN": "Tunisie",
        "TO": "Tonga",
        "TR": "Turquie",
        "TT": "Trinité-et-Tobago",
        "TV": "Tuvalu",
        "TW": "Taïwan",
        "TZ": "Tanzanie",
        "UA": "Ukraine",
        "UG": "Ouganda",
        "US": "États Unis",
        "UY": "Uruguay",
        "UZ": "Ouzbékistan",
        "VA": "Vatican",
        "VC": "Saint-Vincent-et-les-Grenadines",
        "VE": "Venezuela",
        "VG": "Îles Vierges britanniques",
        "VI": "Îles Vierges américaines",
        "VN": "Viêt-Nam",
        "VU": "Vanuatu",
        "WF": "Wallis et Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yémen",
        "YT": "Mayotte",
        "ZA": "Afrique du Sud",
        "ZM": "Zambie",
        "ZW": "Zimbabwe"
    },
    "idid": {
        "AD": "Andorra",
        "AE": "Uni Emirat Arab",
        "AF": "Afganistan",
        "AG": "Antigua dan Barbuda",
        "AI": "anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Antillen Belanda",
        "AO": "Angola",
        "AQ": "Antartika",
        "AR": "Argentina",
        "AS": "Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia dan Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgia",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahama",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Kanada",
        "CC": "Kepulauan Cocos",
        "CD": "Republik Demokratik Kongo",
        "CF": "Republik Afrika Tengah",
        "CG": "Republik Demokratik Kongo",
        "CH": "Swiss",
        "CI": "Pantai Gading",
        "CK": "Kepulauan cook",
        "CL": "Chili",
        "CM": "Kamerun",
        "CN": "Cina",
        "CO": "Kolumbia",
        "CR": "Costa Rica",
        "CU": "Kuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Pulau Natal",
        "CY": "Siprus",
        "CZ": "Republik Ceko",
        "DE": "Jerman",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Republik Dominika",
        "DZ": "Aljazair",
        "EC": "Ekuador",
        "EE": "Estonia",
        "EG": "Mesir",
        "EH": "Sahara Barat",
        "ER": "Eritrea",
        "ES": "Spanyol",
        "ET": "Etiopia",
        "FI": "Finlandia",
        "FJ": "Fiji",
        "FK": "Kepulauan Falkland",
        "FM": "Mikronesia",
        "FO": "Kepulauan Faroe",
        "FR": "Prancis",
        "GA": "Gabon",
        "GB": "Inggris",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "tanah penggembalaan",
        "GM": "Gambia",
        "GN": "guinea",
        "GQ": "Equatorial Guinea",
        "GR": "Yunani",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "guyana",
        "HK": "Hong Kong",
        "HN": "honduras",
        "HR": "Kroasia",
        "HT": "Haiti",
        "HU": "Hongaria",
        "ID": "Indonesia",
        "IE": "Irlandia",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "Britania di Samudra Hindia",
        "IQ": "Irak",
        "IR": "Iran",
        "IS": "Islandia",
        "IT": "Italia",
        "JE": "New Jersey",
        "JM": "Jamaika",
        "JO": "Jordan",
        "JP": "Jepang",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Kamboja",
        "KI": "Kiribati",
        "KM": "Komoro",
        "KN": "Saint Kitts dan Nevis",
        "KP": "Korea utara",
        "KR": "Korea",
        "KW": "Kuwait",
        "KY": "Kepulauan Cayman",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Libanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luksemburg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Maroko",
        "MC": "Monako",
        "MD": "Moldova",
        "ME": "montenegro",
        "MF": "San Martin",
        "MG": "Madagaskar",
        "MH": "Kepulauan Marshall",
        "MK": "Makedonia",
        "ML": "mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "Makao",
        "MP": "Kepulauan Mariana Utara",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maladewa",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambik",
        "NA": "Namibia",
        "NC": "Kaledonia baru",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nikaragua",
        "NL": "Belanda",
        "NO": "Norwegia",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "Selandia baru",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "Polinesia Prancis",
        "PG": "Papua Nugini",
        "PH": "Pilipina",
        "PK": "Pakistan",
        "PL": "Polandia",
        "PM": "Saint Pierre dan Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestina",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguai",
        "QA": "Qatar",
        "RE": "reuni",
        "RO": "Rumania",
        "RS": "Serbia",
        "RU": "Rusia",
        "RW": "Rwanda",
        "SA": "Arab Saudi",
        "SB": "Kepulauan Solomon",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Swedia",
        "SG": "Singapura",
        "SH": "St. Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "Sudan Selatan",
        "ST": "Sao Tome dan Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Suriah",
        "SZ": "Swaziland",
        "TC": "Kepulauan Turks dan Caicos",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Timor timur",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turki",
        "TT": "Trinidad dan Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraina",
        "UG": "Uganda",
        "US": "AS",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Takhta suci",
        "VC": "Saint Vincent dan Grenadines",
        "VE": "Venezuela",
        "VG": "Kepulauan Virgin Inggris",
        "VI": "Amerika Serikat Kepulauan Virgin",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis dan Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yaman",
        "YT": "Mayotte",
        "ZA": "Afrika Selatan",
        "ZM": "Zambia",
        "ZW": "Zimbabwe"
    },
    "jajp": {
        "<%=userName%>坐着<%=carName%>进入了直播间": "<%=userName%>は<%=carName%>ライブ配信に来ました",
        "AD": "アンドラ",
        "AE": "アラブ首長国連邦",
        "AF": "アフガニスタン",
        "AG": "アンチグアバーブーダ",
        "AI": "アングィラ",
        "AL": "アルバニア",
        "AM": "アルメニア",
        "AN": "オランダ領アンティル",
        "AO": "アンゴラ",
        "AQ": "南極大陸",
        "AR": "アルゼンチン",
        "AS": "アメリカ領サモア",
        "AT": "オーストリア",
        "AU": "オーストラリア",
        "AW": "アルバ",
        "AZ": "アゼルバイジャン",
        "BA": "ボスニア・ヘルツェゴビナ",
        "BB": "バルバドス",
        "BD": "バングラデシュ",
        "BE": "ベルギー",
        "BF": "ブルキナファソ",
        "BG": "ブルガリア",
        "BH": "バーレーン",
        "BI": "ブルンジ",
        "BJ": "ベニン",
        "BL": "セントバーツ",
        "BM": "バミューダ",
        "BN": "ブルネイ",
        "BO": "ボリビア",
        "BR": "ブラジル",
        "BS": "バハマ",
        "BT": "ブータン",
        "BW": "ボツワナ",
        "BY": "ベラルーシ",
        "BZ": "ベリーズ",
        "CA": "カナダ",
        "CC": "ココス諸島",
        "CD": "コンゴ民主共和国",
        "CF": "中央アフリカ共和国",
        "CG": "コンゴ共和国",
        "CH": "スイス",
        "CI": "コー​​トジボワール",
        "CK": "クック諸島",
        "CL": "チリ",
        "CM": "カメルーン",
        "CN": "中国",
        "CO": "コロンビア",
        "CR": "コスタリカ",
        "CU": "キューバ",
        "CV": "カーボベルデ",
        "CW": "キュラソー",
        "CX": "クリスマス島",
        "CY": "キプロス",
        "CZ": "チェコ共和国",
        "DE": "ドイツ",
        "DJ": "ジブチ",
        "DK": "デンマーク",
        "DM": "ドミニカ",
        "DO": "ドミニカ共和国",
        "DZ": "アルジェリア",
        "EC": "エクアドル",
        "EE": "エストニア",
        "EG": "エジプト",
        "EH": "西サハラ",
        "ER": "エリトリア",
        "ES": "スペイン",
        "ET": "エチオピア",
        "FI": "フィンランド",
        "FJ": "フィジー",
        "FK": "フォークランド諸島",
        "FM": "ミクロネシア",
        "FO": "フェロー諸島",
        "FR": "フランス",
        "GA": "ガボン",
        "GB": "イギリス",
        "GD": "グレナダ",
        "GE": "ジョージア",
        "GG": "ガーンジー島",
        "GH": "ガーナ",
        "GI": "ジブラルタル",
        "GL": "グリーンランド",
        "GM": "ガンビア",
        "GN": "ギニア",
        "GQ": "赤道ギニア",
        "GR": "ギリシャ",
        "GT": "グアテマラ",
        "GU": "グアム",
        "GW": "ギニアビサウ",
        "GY": "ガイアナ",
        "HK": "香港",
        "HN": "ホンジュラス",
        "HR": "クロアチア",
        "HT": "ハイチ",
        "HU": "ハンガリー",
        "ID": "インドネシア",
        "IE": "アイルランド",
        "IL": "イスラエル",
        "IM": "マン島",
        "IN": "インド",
        "IO": "イギリス領インド洋地域",
        "IQ": "イラク",
        "IR": "イラン",
        "IS": "アイスランド",
        "IT": "イタリア",
        "JE": "ジャージー",
        "JM": "ジャマイカ",
        "JO": "ヨルダン",
        "JP": "日本",
        "KE": "ケニア",
        "KG": "キルギスタン",
        "KH": "カンボジア",
        "KI": "キリバス",
        "KM": "コモロ",
        "KN": "セントクリストファー・ネイビス",
        "KP": "北朝鮮",
        "KR": "韓国",
        "KW": "クウェート",
        "KY": "ケイマン諸島",
        "KZ": "カザフスタン",
        "LA": "ラオス",
        "LB": "レバノン",
        "LC": "セントルシア",
        "LI": "リヒテンシュタイン",
        "LK": "スリランカ",
        "LR": "リベリア",
        "LS": "レソト",
        "LT": "リトアニア",
        "LU": "ルクセンブルク",
        "LV": "ラトビア",
        "LY": "リビア",
        "MA": "モロッコ",
        "MC": "モナコ",
        "MD": "モルドバ",
        "ME": "モンテネグロ",
        "MF": "サンマルタン島",
        "MG": "マダガスカル",
        "MH": "マーシャル諸島",
        "MK": "マケドニア",
        "ML": "マリ",
        "MM": "ミャンマー",
        "MN": "モンゴル",
        "MO": "マカオ",
        "MP": "北マリアナ諸島",
        "MR": "モーリタニア",
        "MS": "モントセラト",
        "MT": "マルタ",
        "MU": "モーリシャス",
        "MV": "モルディブ",
        "MW": "マラウイ",
        "MX": "メキシコ",
        "MY": "マレーシア",
        "MZ": "モザンビーク",
        "NA": "ナミビア",
        "NC": "ニューカレドニア",
        "NE": "ニジェール",
        "NG": "ナイジェリア",
        "NI": "ニカラグア",
        "NL": "オランダ",
        "NO": "ノルウェー",
        "NP": "ネパール",
        "NR": "ナウル",
        "NU": "ニウエ",
        "NZ": "ニュージーランド",
        "OM": "オマーン",
        "PA": "パナマ",
        "PE": "ペルー",
        "PF": "フランス領ポリネシア",
        "PG": "パプアニューギニア",
        "PH": "フィリピン",
        "PK": "パキスタン",
        "PL": "ポーランド",
        "PM": "サンピエール島・ミクロン島",
        "PN": "ピトケアン",
        "PR": "プエルトリコ",
        "PS": "パレスチナ",
        "PT": "ポルトガル",
        "PW": "パラオ",
        "PY": "パラグアイ",
        "QA": "カタール",
        "RE": "再会",
        "RO": "ルーマニア",
        "RS": "セルビア",
        "RU": "ロシア",
        "RW": "ルワンダ",
        "SA": "サウジアラビア",
        "SB": "ソロモン諸島",
        "SC": "セイシェル",
        "SD": "スーダン",
        "SE": "スウェーデン",
        "SG": "シンガポール",
        "SH": "セントヘレナ",
        "SI": "スロベニア",
        "SJ": "スバールバル諸島ヤンマイエン島",
        "SK": "スロバキア",
        "SL": "シエラレオネ",
        "SM": "サン・マリノ",
        "SN": "セネガル",
        "SO": "ソマリア",
        "SR": "スリナム",
        "SS": "南スーダン",
        "ST": "サントメプリンシペ",
        "SV": "エルサルバドル",
        "SX": "シントマールテン島",
        "SY": "シリア",
        "SZ": "スワジランド",
        "TC": "タークス・カイコス諸島",
        "TD": "チャド",
        "TG": "行く",
        "TH": "タイ",
        "TJ": "タジキスタン",
        "TK": "トケラウ諸島",
        "TL": "東ティモール",
        "TM": "トルクメニスタン",
        "TN": "チュニジア",
        "TO": "トンガ",
        "TR": "トルコ",
        "TT": "トリニダード・トバゴ",
        "TV": "ツバル",
        "TW": "台湾",
        "TZ": "タンザニア",
        "UA": "ウクライナ",
        "UG": "ウガンダ",
        "US": "アメリカ",
        "UY": "ウルグアイ",
        "UZ": "ウズベキスタン",
        "Up号:<%=code%>": "Upアカンウト:<%=code%>",
        "Up直播": "UpLive",
        "U币贡献榜": "貢献ランキング",
        "VA": "バチカン",
        "VC": "セントビンセントおよびグレナディーン諸島",
        "VE": "ベネズエラ",
        "VG": "イギリス領バージン諸島",
        "VI": "米領バージン諸島",
        "VN": "ベトナム",
        "VU": "バヌアツ",
        "WF": "ワリー・エ・フトゥーナ",
        "WS": "サモア",
        "XK": "コソボ",
        "YE": "イエメン",
        "YT": "マヨット島",
        "ZA": "南アフリカ",
        "ZM": "ザンビア",
        "ZW": "ジンバブエ",
        "个人信息设定失败": "プロフィール設定失敗",
        "个人信息设定成功": "プロフィール設定完了",
        "主播可能在休息，稍后再来试试吧": "キャストは休憩中です。後ほどお越しください！",
        "主播已停播，即将返回首页!": "ライブ終了す。ホームページに戻ります！",
        "优秀主播指南": "ハイクォリティキャストマニュアル",
        "余额不足情况下，充值提醒的描述": "ダイヤが不足す、チャージしますか？",
        "你关注的人还没有直播": "フォロー中のキャストは現在ライブ配信をしていません",
        "保存": "保存",
        "充值 >": "チャージ >",
        "关注": "フォロー",
        "关注了主播，从此不再错过。": "このキャストをフォローしました",
        "写个签名吧，让大家了解你。": "自己紹介を書いて、みんなにあなたを知ってもらいましょう！",
        "分享失败": "シェア失敗しました！",
        "分享成功": "シェアしました！",
        "去看看当前热门直播": "現在人気のライブ",
        "参数无效": "パラメータが無効です",
        "参数错误": "パラメータエラー",
        "发现": "新着",
        "发现新主播": "新着キャスト",
        "发送": "送信",
        "取消": "キャンセル",
        "如何升级": "レベルアップ",
        "如何升级详情": "レベルアップの方法",
        "守护身价:<%=code%>": "SPになる:<%=code%>",
        "已停播": "配信停止しました",
        "已关注": "フォローしました",
        "已取消分享": "シェアをキャンセルしました",
        "我的U钻": "ダイヤ",
        "我的守护": "私のSP",
        "我的收益（U币）": "収入（コイン）",
        "我的直播": "ライブ配信確認",
        "我的等级": "レベル",
        "拉黑": "ブロックします",
        "按语言推荐主播": "言語別人気キャスト",
        "搜索": "検索",
        "收到的U币": "受け取ったコイン",
        "昵称不能出现敏感词": "ニックネームにはNGワードを記入することはきません",
        "暂无数据": "データがありません",
        "暂无被拉黑用户": "ブロックされたユーザーがいません",
        "未知星球": "位置情報が取得きません",
        "正在加载": "ローディング中",
        "正在加载更多的数据...": "データ更新中",
        "没发现此人，请重新输入试试": "見つかりませんした、もう一度お試しください",
        "没有更多数据了哦": "これ以上のデータがありません",
        "点亮了": "いいね",
        "热门": "人気",
        "用户登录失效": "ログイン失敗しました",
        "登出": "ログアウト",
        "直播中": "ライブ配信",
        "确认": "確認",
        "等级福利": "レベル特典",
        "等级福利详情": "レベル特典の詳細",
        "签名不能出现敏感词": "自己紹介にはNGワードを記入することはきません",
        "粉丝": "ファン",
        "系统消息": "システムエラー",
        "系统消息: 主播回来了，视频即将恢复！": "お知らせ：キャストが戻ってきました！",
        "系统消息: 主播暂时离开了，小伙伴们请稍候。": "お知らせ：キャストが席をはなれました。戻ってくるまお待ちください！",
        "系统消息: 我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。": "お知らせ：利用規約に基づくライブ配信を行いましょう。24時間体制パトロールを行っており、露出、喫煙などの規約違反がある場合、アカウント停止を行う場合があります。協力して魅力的なライブ配信環境を築きましょう!!",
        "系统错误": "システムエラー",
        "累计经验：<%=code%>": "経験値：<%=code%>",
        "经验值<%=num%>": "経験値<%=num%>",
        "花费:": "貢献：",
        "获取个人信息失败": "個人情報の読み取りが失敗",
        "获取成功": "獲得成功",
        "获取热门主播失败": "人気欄キャスト一覧を表示きませんした",
        "虚位以待": "空席",
        "解除拉黑": "ブロック解除",
        "设置国家或地区失败": "国、地域設定失敗",
        "设置国家或地区成功": "国、地域設定完了",
        "说点什么吧": "何かお話しましょう",
        "请竖屏获得更佳体验": "スクリーンを縦にするとより良い体験がきます！",
        "请输入用户昵称或Up号": "ニックネーム、またはUpアカウントを入力してください",
        "贡献U币:<%=code%>": "貢献：<%=code%>",
        "赠送": "贈る",
        "赠送了<%=count%>个<%=giftName%>": "贈りました：<%=count%>個<%=giftName%>",
        "赠送了<%=giftName%>": "贈りました：<%=giftName%>",
        "距离下一级：<%=code%>": "次のレベルま：<%=code%>",
        "进入房间失败": "ライブ配信に参加失敗",
        "进入房间超时": "ライブ配信に参加タイムオーバ",
        "连": "+1",
        "连接失败，请退出直播间重新进入": "接続エラー、再度お試しください",
        "选择国家或地区": "国、地域を選択",
        "重新选择": "再度選択",
        "黑名单": "ブロックリスト"
    },
    "kokr": {
        "AD": "안도라",
        "AE": "아랍 에미리트",
        "AF": "아프가니스탄",
        "AG": "앤티가 바부 다",
        "AI": "앵 귈라",
        "AL": "알바니아",
        "AM": "아르메니아",
        "AN": "네덜란드 령 앤 틸리 스",
        "AO": "앙골라",
        "AQ": "남극 대륙",
        "AR": "아르헨티나",
        "AS": "사모아",
        "AT": "오스트리아",
        "AU": "호주",
        "AW": "아루바",
        "AZ": "아제르바이잔",
        "BA": "보스니아 헤르체고비나",
        "BB": "바베이도스",
        "BD": "방글라데시",
        "BE": "벨기에",
        "BF": "부르 키나 파소",
        "BG": "불가리아",
        "BH": "바레인",
        "BI": "부룬디",
        "BJ": "베냉",
        "BL": "세인트 Barthelemy",
        "BM": "버뮤다",
        "BN": "브루나이",
        "BO": "볼리비아",
        "BR": "브라질",
        "BS": "바하마",
        "BT": "부탄",
        "BW": "보츠와나",
        "BY": "벨라루스",
        "BZ": "벨리즈",
        "CA": "캐나다",
        "CC": "코코스 아일랜드",
        "CD": "콩고 민주 공화국",
        "CF": "중앙 아프리카 공화국",
        "CG": "콩고 민주 공화국",
        "CH": "스위스",
        "CI": "상아 해안",
        "CK": "쿡 제도",
        "CL": "칠레",
        "CM": "카메룬",
        "CN": "중국",
        "CO": "콜롬비아",
        "CR": "코스타리카",
        "CU": "쿠바",
        "CV": "카보 베르데",
        "CW": "쿠라 카오",
        "CX": "크리스마스 제도",
        "CY": "키프로스",
        "CZ": "체코 공화국",
        "DE": "독일",
        "DJ": "지부티",
        "DK": "덴마크",
        "DM": "도미니카",
        "DO": "도미니카 공화국",
        "DZ": "알제리",
        "EC": "에콰도르",
        "EE": "에스토니아",
        "EG": "이집트",
        "EH": "서부 사하라",
        "ER": "에리트레아",
        "ES": "스페인",
        "ET": "에티오피아",
        "FI": "핀란드",
        "FJ": "피지",
        "FK": "포클랜드 제도",
        "FM": "미크로네시아",
        "FO": "파로에 군도",
        "FR": "프랑스",
        "GA": "가봉",
        "GB": "영어",
        "GD": "그레나다",
        "GE": "그루지야",
        "GG": "영국 해협에있는 작은 섬",
        "GH": "가나",
        "GI": "지브롤터",
        "GL": "그린 랜드",
        "GM": "감비아",
        "GN": "기니",
        "GQ": "적도 기니",
        "GR": "그리스",
        "GT": "과테말라",
        "GU": "괌",
        "GW": "기니 비사우",
        "GY": "가이아나",
        "HK": "홍콩",
        "HN": "온두라스",
        "HR": "크로아티아",
        "HT": "아이티",
        "HU": "헝가리",
        "ID": "인도네시아",
        "IE": "아일랜드",
        "IL": "이스라엘",
        "IM": "아일 오브 맨",
        "IN": "인도",
        "IO": "영국령 인도양 지역",
        "IQ": "이라크",
        "IR": "이란",
        "IS": "아이슬란드",
        "IT": "이탈리아",
        "JE": "뉴저지",
        "JM": "자메이카",
        "JO": "요르단",
        "JP": "일본",
        "KE": "케냐",
        "KG": "키르기스스탄",
        "KH": "캄보디아",
        "KI": "키리바시",
        "KM": "코모로",
        "KN": "세인트 키츠 네비스",
        "KP": "북한",
        "KR": "한국",
        "KW": "쿠웨이트",
        "KY": "케이맨 제도",
        "KZ": "카자흐스탄",
        "LA": "라오스",
        "LB": "레바논",
        "LC": "세인트 루시아",
        "LI": "리히텐슈타인",
        "LK": "스리랑카",
        "LR": "라이베리아",
        "LS": "레소토",
        "LT": "리투아니아",
        "LU": "룩셈부르크",
        "LV": "라트비아",
        "LY": "리비아",
        "MA": "모로코",
        "MC": "모나코",
        "MD": "몰르 더바",
        "ME": "몬테네그로",
        "MF": "산 마르틴",
        "MG": "마다가스카르",
        "MH": "마샬 군도",
        "MK": "마케도니아",
        "ML": "말리",
        "MM": "미얀마",
        "MN": "몽골리아",
        "MO": "마카오",
        "MP": "북 마리아나 제도",
        "MR": "모리타니",
        "MS": "몬 세라",
        "MT": "몰타",
        "MU": "모리셔스",
        "MV": "몰디브",
        "MW": "말라위",
        "MX": "멕시코",
        "MY": "말레이시아",
        "MZ": "모잠비크",
        "NA": "나미비아",
        "NC": "뉴 칼레도니아",
        "NE": "니제르",
        "NG": "나이지리아",
        "NI": "니카라과",
        "NL": "네덜란드",
        "NO": "노르웨이",
        "NP": "네팔",
        "NR": "나우루어",
        "NU": "니우에",
        "NZ": "뉴질랜드",
        "OM": "오만",
        "PA": "파나마",
        "PE": "페루",
        "PF": "프랑스 령 폴리네시아의",
        "PG": "파푸아 뉴기니",
        "PH": "필리핀",
        "PK": "파키스탄",
        "PL": "폴란드",
        "PM": "생 피에르 미 클롱",
        "PN": "핏 케언",
        "PR": "푸에르토 리코",
        "PS": "팔레스타인",
        "PT": "포르투갈",
        "PW": "팔라우",
        "PY": "파라과이",
        "QA": "카타르",
        "RE": "재결합",
        "RO": "루마니아",
        "RS": "세르비아",
        "RU": "러시아",
        "RW": "르완다",
        "SA": "사우디 아라비아",
        "SB": "솔로몬 제도",
        "SC": "세이셸",
        "SD": "수단",
        "SE": "스웨덴",
        "SG": "싱가포르",
        "SH": "세인트 헬레나",
        "SI": "슬로베니아",
        "SJ": "스발 바르",
        "SK": "슬로바키아",
        "SL": "시에라 리온",
        "SM": "산 마리노",
        "SN": "세네갈",
        "SO": "소말리아",
        "SR": "수리남",
        "SS": "남 수단",
        "ST": "상투 메 프린시 페",
        "SV": "엘살바도르",
        "SX": "세인트 마틴",
        "SY": "시리아",
        "SZ": "스와질란드",
        "TC": "터크 스 케이 커스 제도",
        "TD": "차드",
        "TG": "토고",
        "TH": "태국",
        "TJ": "타지키스탄",
        "TK": "토켈 라우",
        "TL": "동 티모르",
        "TM": "투르크 메니스탄",
        "TN": "튀니지",
        "TO": "통가",
        "TR": "터키",
        "TT": "트리니다드 토바고",
        "TV": "투발루",
        "TW": "대만",
        "TZ": "탄자니아",
        "UA": "우크라이나",
        "UG": "우간다",
        "US": "미국",
        "UY": "우루과이",
        "UZ": "우즈베키스탄",
        "VA": "교황청",
        "VC": "세인트 빈센트 그레나딘",
        "VE": "베네수엘라",
        "VG": "영국령 버진 아일랜드",
        "VI": "미국 버진 아일랜드",
        "VN": "베트남",
        "VU": "바누아투",
        "WF": "월리스 푸 투나",
        "WS": "사모아",
        "XK": "코소보",
        "YE": "예멘",
        "YT": "마 요트",
        "ZA": "남아프리카 공화국",
        "ZM": "잠비아",
        "ZW": "짐바브웨"
    },
    "msmy": {
        "AD": "Andorra",
        "AE": "United Arab Emirates",
        "AF": "Afghanistan",
        "AG": "Antigua dan Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Antillen Belanda",
        "AO": "Angola",
        "AQ": "Antartika",
        "AR": "Argentina",
        "AS": "Samoa",
        "AT": "Austria",
        "AU": "Australia",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia dan Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Belgium",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Kanada",
        "CC": "Kepulauan Cocos",
        "CD": "Republik Demokratik Congo",
        "CF": "Republik Afrika Tengah",
        "CG": "Republik Demokratik Congo",
        "CH": "Switzerland",
        "CI": "Ivory Coast",
        "CK": "Kepulauan Cook",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "China",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Pulau Krismas",
        "CY": "Cyprus",
        "CZ": "Republik Czech",
        "DE": "Jerman",
        "DJ": "Djibouti",
        "DK": "Denmark",
        "DM": "Dominica",
        "DO": "Republik Dominican",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Mesir",
        "EH": "Sahara Barat",
        "ER": "Eritrea",
        "ES": "Sepanyol",
        "ET": "Ethiopia",
        "FI": "Finland",
        "FJ": "Fiji",
        "FK": "Kepulauan Falkland",
        "FM": "Micronesia",
        "FO": "Kepulauan Faroe",
        "FR": "Perancis",
        "GA": "Gabon",
        "GB": "English",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Guinea Khatulistiwa",
        "GR": "Greece",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "India",
        "IO": "British Indian Ocean Territory",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Italy",
        "JE": "New Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Jepun",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Kemboja",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts dan Nevis",
        "KP": "Korea Utara",
        "KR": "Korea",
        "KW": "Kuwait",
        "KY": "Pulau Cayman",
        "KZ": "Kazakhstan",
        "LA": "Laos",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "San Martin",
        "MG": "Madagascar",
        "MH": "Kepulauan Marshall",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongolia",
        "MO": "Macao",
        "MP": "Kepulauan Mariana Utara",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Belanda",
        "NO": "Norway",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "Polynesia Perancis",
        "PG": "Papua New Guinea",
        "PH": "filipina",
        "PK": "pakistan",
        "PL": "Poland",
        "PM": "Saint Pierre dan Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestin",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Rusia",
        "RW": "Rwanda",
        "SA": "Arab Saudi",
        "SB": "Kepulauan Solomon",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Sweden",
        "SG": "Singapura",
        "SH": "St. Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Surinam",
        "SS": "South Sudan",
        "ST": "Sao Tome dan Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TC": "Kepulauan Turks dan Caicos",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thailand",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Timor Timur",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turki",
        "TT": "Trinidad dan Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzania",
        "UA": "Ukraine",
        "UG": "Uganda",
        "US": "Amerika Syarikat",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "VA": "Holy See",
        "VC": "Saint Vincent dan Grenadines",
        "VE": "Venezuela",
        "VG": "Kepulauan British Virgin",
        "VI": "Amerika Syarikat Kepulauan Virgin",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis dan Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yaman",
        "YT": "Mayotte",
        "ZA": "Afrika Selatan",
        "ZM": "Zambia",
        "ZW": "Zimbabwe"
    },
    "ptpt": {
        "AD": "Andorra",
        "AE": "Emirados Árabes Unidos",
        "AF": "Afeganistão",
        "AG": "Antígua e Barbuda",
        "AI": "Anguilla",
        "AL": "Albânia",
        "AM": "Armênia",
        "AN": "Antilhas Holandesas",
        "AO": "Angola",
        "AQ": "Antártica",
        "AR": "Argentina",
        "AS": "Samoa Americana",
        "AT": "Áustria",
        "AU": "Austrália",
        "AW": "Aruba",
        "AZ": "Azerbaijão",
        "BA": "Bósnia e Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Bélgica",
        "BF": "Burkina Faso",
        "BG": "Bulgária",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "saint Barthelemy",
        "BM": "Bermudas",
        "BN": "Brunei",
        "BO": "Bolívia",
        "BR": "Brasil",
        "BS": "Bahamas",
        "BT": "Butão",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canadá",
        "CC": "Ilhas Cocos",
        "CD": "República Democrática do Congo",
        "CF": "Central Africano República",
        "CG": "República do Congo",
        "CH": "Suíça",
        "CI": "Costa do Marfim",
        "CK": "Ilhas Cook",
        "CL": "Chile",
        "CM": "Camarões",
        "CN": "China",
        "CO": "Colômbia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "cabo Verde",
        "CW": "Curacao",
        "CX": "Ilhas de Natal",
        "CY": "Chipre",
        "CZ": "República Checa",
        "DE": "Alemanha",
        "DJ": "Djibouti",
        "DK": "Dinamarca",
        "DM": "Dominica",
        "DO": "República Dominicana",
        "DZ": "Argélia",
        "EC": "Equador",
        "EE": "Estônia",
        "EG": "Egito",
        "EH": "Saara Ocidental",
        "ER": "Eritrea",
        "ES": "Espanha",
        "ET": "Etiópia",
        "FI": "Finlândia",
        "FJ": "Fiji",
        "FK": "Ilhas Falkland",
        "FM": "Micronesia",
        "FO": "ilhas Faroe",
        "FR": "França",
        "GA": "Gabão",
        "GB": "Reino Unido",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Gana",
        "GI": "Gibraltar",
        "GL": "Groenlândia",
        "GM": "Gâmbia",
        "GN": "Guiné",
        "GQ": "Guiné Equatorial",
        "GR": "Grécia",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guiné-Bissau",
        "GY": "Guiana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Croácia",
        "HT": "Haiti",
        "HU": "Hungria",
        "ID": "Indonésia",
        "IE": "Irlanda",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "Índia",
        "IO": "Território Britânico do Oceano Índico",
        "IQ": "Iraque",
        "IR": "Irã",
        "IS": "Islândia",
        "IT": "Itália",
        "JE": "camisola",
        "JM": "Jamaica",
        "JO": "Jordânia",
        "JP": "Japão",
        "KE": "Quênia",
        "KG": "Quirguistão",
        "KH": "Camboja",
        "KI": "Kiribati",
        "KM": "Comores",
        "KN": "São Cristóvão e Nevis",
        "KP": "Coreia do Norte",
        "KR": "Coreia do Sul",
        "KW": "Kuweit",
        "KY": "Ilhas Cayman",
        "KZ": "Cazaquistão",
        "LA": "Laos",
        "LB": "Líbano",
        "LC": "Santa Lúcia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Libéria",
        "LS": "Lesoto",
        "LT": "Lituânia",
        "LU": "Luxemburgo",
        "LV": "Letônia",
        "LY": "Líbia",
        "MA": "Marrocos",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "saint Martin",
        "MG": "Madagáscar",
        "MH": "Ilhas Marshall",
        "MK": "Macedónia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mongólia",
        "MO": "Macau",
        "MP": "Ilhas Marianas do Norte",
        "MR": "Mauritânia",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldivas",
        "MW": "Malavi",
        "MX": "México",
        "MY": "Malásia",
        "MZ": "Moçambique",
        "NA": "Namíbia",
        "NC": "Nova Caledônia",
        "NE": "Níger",
        "NG": "Nigéria",
        "NI": "Nicarágua",
        "NL": "países Baixos",
        "NO": "Noruega",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "Nova Zelândia",
        "OM": "Omã",
        "PA": "Panamá",
        "PE": "Peru",
        "PF": "Polinésia Francesa",
        "PG": "Papua Nova Guiné",
        "PH": "Filipinas",
        "PK": "Paquistão",
        "PL": "Polônia",
        "PM": "Saint Pierre e Miquelon",
        "PN": "Pitcairn",
        "PR": "Porto Rico",
        "PS": "Palestina",
        "PT": "Portugal",
        "PW": "Palau",
        "PY": "Paraguai",
        "QA": "Catar",
        "RE": "Reunião",
        "RO": "Romênia",
        "RS": "Sérvia",
        "RU": "Rússia",
        "RW": "Ruanda",
        "SA": "Arábia Saudita",
        "SB": "Ilhas Salomão",
        "SC": "Seychelles",
        "SD": "Sudão",
        "SE": "Suécia",
        "SG": "Cingapura",
        "SH": "Santa Helena",
        "SI": "Eslovenia",
        "SJ": "Svalbard e Jan Mayen",
        "SK": "Eslováquia",
        "SL": "Serra Leoa",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somália",
        "SR": "Suriname",
        "SS": "Sudão do Sul",
        "ST": "São Tomé e Príncipe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Síria",
        "SZ": "Suazilândia",
        "TC": "Ilhas Turks e Caicos",
        "TD": "Chade",
        "TG": "Ir",
        "TH": "Tailândia",
        "TJ": "Tajiquistão",
        "TK": "Tokelau",
        "TL": "Timor Leste",
        "TM": "Turquemenistão",
        "TN": "Tunísia",
        "TO": "Tonga",
        "TR": "Turquia",
        "TT": "Trinidad e Tobago",
        "TV": "Tuvalu",
        "TW": "Taiwan",
        "TZ": "Tanzânia",
        "UA": "Ucrânia",
        "UG": "Uganda",
        "US": "Estados Unidos",
        "UY": "Uruguai",
        "UZ": "Uzbequistão",
        "VA": "Vaticano",
        "VC": "São Vicente e Granadinas",
        "VE": "Venezuela",
        "VG": "Ilhas Virgens Britânicas",
        "VI": "Ilhas Virgens Americanas",
        "VN": "Vietnã",
        "VU": "Vanuatu",
        "WF": "Wallis e Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Iémen",
        "YT": "Mayotte",
        "ZA": "África do Sul",
        "ZM": "Zâmbia",
        "ZW": "Zimbábue"
    },
    "ruru": {
        "AD": "андорра",
        "AE": "Объединенные Арабские Эмираты",
        "AF": "Афганистан",
        "AG": "Антигуа и Барбуда",
        "AI": "Ангилья",
        "AL": "Албания",
        "AM": "Армения",
        "AN": "Нидерландские Антильские острова",
        "AO": "Ангола",
        "AQ": "Антарктида",
        "AR": "Аргентина",
        "AS": "Самоа",
        "AT": "Австрия",
        "AU": "Австралия",
        "AW": "Аруба",
        "AZ": "Азербайджан",
        "BA": "Босния и Герцеговина",
        "BB": "Барбадос",
        "BD": "Бангладеш",
        "BE": "Бельгия",
        "BF": "Буркина-Фасо",
        "BG": "Болгария",
        "BH": "Бахрейн",
        "BI": "Бурунди",
        "BJ": "Бенин",
        "BL": "Сен-Бартельми",
        "BM": "Бермудские острова",
        "BN": "Бруней",
        "BO": "Боливия",
        "BR": "Бразилия",
        "BS": "Багамские о-ва",
        "BT": "Бутан",
        "BW": "Ботсвана",
        "BY": "Беларусь",
        "BZ": "Белиз",
        "CA": "Канада",
        "CC": "Кокосовые острова",
        "CD": "Демократическая Республика Конго",
        "CF": "Центрально-Африканская Республика",
        "CG": "Демократическая Республика Конго",
        "CH": "Швейцария",
        "CI": "Берег Слоновой Кости",
        "CK": "Острова Кука",
        "CL": "Чили",
        "CM": "Камерун",
        "CN": "Китай",
        "CO": "Колумбия",
        "CR": "Коста-Рика",
        "CU": "Куба",
        "CV": "Кабо-Верде",
        "CW": "ликер кюрасо",
        "CX": "Рождественские острова",
        "CY": "Кипр",
        "CZ": "Чехия",
        "DE": "Германия",
        "DJ": "Джибути",
        "DK": "Дания",
        "DM": "Доминика",
        "DO": "Доминиканская Республика",
        "DZ": "Алжир",
        "EC": "Эквадор",
        "EE": "Эстония",
        "EG": "Египет",
        "EH": "Западная Сахара",
        "ER": "Эритрея",
        "ES": "Испания",
        "ET": "Эфиопия",
        "FI": "Финляндия",
        "FJ": "Фиджи",
        "FK": "Фолклендские острова",
        "FM": "Микронезия",
        "FO": "Фарерские острова",
        "FR": "Франция",
        "GA": "Габон",
        "GB": "английский",
        "GD": "Гренада",
        "GE": "Грузия",
        "GG": "шерстяная фуфайка",
        "GH": "Гана",
        "GI": "Гибралтар",
        "GL": "Гренландия",
        "GM": "Гамбия",
        "GN": "Гвинея",
        "GQ": "Экваториальная Гвинея",
        "GR": "Греция",
        "GT": "Гватемала",
        "GU": "Гуам",
        "GW": "Гвинея-Бисау",
        "GY": "Гайана",
        "HK": "Гонконг",
        "HN": "Гондурас",
        "HR": "Хорватия",
        "HT": "Гаити",
        "HU": "Венгрия",
        "ID": "Индонезия",
        "IE": "Ирландия",
        "IL": "Израиль",
        "IM": "Остров Мэн",
        "IN": "Индия",
        "IO": "Британская территория в Индийском океане",
        "IQ": "Ирак",
        "IR": "Иран",
        "IS": "Исландия",
        "IT": "Италия",
        "JE": "Нью-Джерси",
        "JM": "Ямайка",
        "JO": "Иордания",
        "JP": "Япония",
        "KE": "Кения",
        "KG": "Киргизия",
        "KH": "Камбоджа",
        "KI": "Кирибати",
        "KM": "Коморские острова",
        "KN": "Сент-Китс и Невис",
        "KP": "Северная Корея",
        "KR": "Корея",
        "KW": "Кувейт",
        "KY": "Каймановы острова",
        "KZ": "Казахстан",
        "LA": "Лаос",
        "LB": "Ливан",
        "LC": "Сент-Люсия",
        "LI": "Лихтенштейн",
        "LK": "Шри Ланка",
        "LR": "Либерия",
        "LS": "Лесото",
        "LT": "Литва",
        "LU": "Люксембург",
        "LV": "Латвия",
        "LY": "Ливия",
        "MA": "Марокко",
        "MC": "Монако",
        "MD": "Молдова",
        "ME": "Черногория",
        "MF": "Сан - Мартин",
        "MG": "Мадагаскар",
        "MH": "Маршалловы острова",
        "MK": "Македония",
        "ML": "Мали",
        "MM": "Мьянма",
        "MN": "Монголия",
        "MO": "Macao",
        "MP": "Северные Марианские острова",
        "MR": "Мавритания",
        "MS": "Монсеррат",
        "MT": "Мальта",
        "MU": "Маврикий",
        "MV": "Мальдивы",
        "MW": "Малави",
        "MX": "Мексика",
        "MY": "Малайзия",
        "MZ": "Мозамбик",
        "NA": "Намибия",
        "NC": "Новая Каледония",
        "NE": "Нигер",
        "NG": "Нигерия",
        "NI": "Никарагуа",
        "NL": "Нидерланды",
        "NO": "Норвегия",
        "NP": "Непал",
        "NR": "Науру",
        "NU": "Niue",
        "NZ": "Новая Зеландия",
        "OM": "Оман",
        "PA": "Панама",
        "PE": "Перу",
        "PF": "Французская Полинезия",
        "PG": "Папуа-Новая Гвинея",
        "PH": "Филиппины",
        "PK": "Пакистан",
        "PL": "Польша",
        "PM": "Сен-Пьер и Микелон",
        "PN": "Питкэрн",
        "PR": "Пуэрто-Рико",
        "PS": "Палестина",
        "PT": "Португалия",
        "PW": "Palau",
        "PY": "Парагвай",
        "QA": "Катар",
        "RE": "воссоединение",
        "RO": "Румыния",
        "RS": "Сербия",
        "RU": "Россия",
        "RW": "Руанда",
        "SA": "Саудовская Аравия",
        "SB": "Соломоновы острова",
        "SC": "Сейшельские острова",
        "SD": "Судан",
        "SE": "Швеция",
        "SG": "Сингапур",
        "SH": "Святой Елены",
        "SI": "Словения",
        "SJ": "Шпицберген",
        "SK": "Словакия",
        "SL": "Сьерра-Леоне",
        "SM": "Сан - Марино",
        "SN": "Сенегал",
        "SO": "Сомали",
        "SR": "Суринам",
        "SS": "Южный Судан",
        "ST": "Сан-Томе и Принсипи",
        "SV": "Сальвадор",
        "SX": "Синт-Маартен",
        "SY": "Сирия",
        "SZ": "Свазиленд",
        "TC": "Острова Теркс и Кайкос",
        "TD": "Чад",
        "TG": "Того",
        "TH": "Таиланд",
        "TJ": "Таджикистан",
        "TK": "Токелау",
        "TL": "Восточный Тимор",
        "TM": "Туркменистан",
        "TN": "Тунис",
        "TO": "Тонга",
        "TR": "Турция",
        "TT": "Тринидад и Тобаго",
        "TV": "Тувалу",
        "TW": "Тайвань",
        "TZ": "Танзания",
        "UA": "Украина",
        "UG": "Уганда",
        "US": "США",
        "UY": "Уругвай",
        "UZ": "Узбекистан",
        "VA": "папский престол",
        "VC": "Сент-Винсент и Гренадины",
        "VE": "Венесуэла",
        "VG": "Британские Виргинские острова",
        "VI": "Виргинские острова Соединенных Штатов",
        "VN": "Вьетнам",
        "VU": "Вануату",
        "WF": "Уоллис и Футуна",
        "WS": "Самоа",
        "XK": "Косово",
        "YE": "Йемен",
        "YT": "Майотта",
        "ZA": "ЮАР",
        "ZM": "Замбия",
        "ZW": "Зимбабве"
    },
    "thth": {
        "AD": "อันดอร์รา",
        "AE": "สหรัฐอาหรับเอมิ",
        "AF": "อัฟกานิสถาน",
        "AG": "แอนติกาและบาร์บูดา",
        "AI": "แองกวิลลา",
        "AL": "แอลเบเนีย",
        "AM": "อาร์เมเนีย",
        "AN": "เนเธอร์แลนด์",
        "AO": "แองโกลา",
        "AQ": "ทวิปแอนตาร์กติกา",
        "AR": "อาร์เจนตินา",
        "AS": "ซามัว",
        "AT": "ออสเตรีย",
        "AU": "ออสเตรเลีย",
        "AW": "อารูบา",
        "AZ": "อาเซอร์ไบจาน",
        "BA": "บอสเนียและเฮอร์เซ",
        "BB": "บาร์เบโดส",
        "BD": "บังคลาเทศ",
        "BE": "เบลเยียม",
        "BF": "Burkina Faso",
        "BG": "บัลแกเรีย",
        "BH": "บาห์เรน",
        "BI": "บุรุนดี",
        "BJ": "ประเทศเบนิน",
        "BL": "เซนต์บาร์เธเล",
        "BM": "เบอร์มิวดา",
        "BN": "บรูไน",
        "BO": "โบลิเวีย",
        "BR": "บราซิล",
        "BS": "บาฮามาส",
        "BT": "ภูฏาน",
        "BW": "บอตสวานา",
        "BY": "เบลารุส",
        "BZ": "เบลีซ",
        "CA": "แคนาดา",
        "CC": "หมู่เกาะโคโค",
        "CD": "สาธารณรัฐประชาธิปไตยคองโก",
        "CF": "สาธารณรัฐแอฟริกากลาง",
        "CG": "สาธารณรัฐประชาธิปไตยคองโก",
        "CH": "ประเทศสวิสเซอร์แลนด์",
        "CI": "ไอวอรี่โคส",
        "CK": "หมู่เกาะคุก",
        "CL": "ชิลี",
        "CM": "แคเมอรูน",
        "CN": "ประเทศจีน",
        "CO": "โคลอมเบีย",
        "CR": "คอสตาริก้า",
        "CU": "คิวบา",
        "CV": "เคปเวิร์ด",
        "CW": "คูราเซา",
        "CX": "เกาะคริสต์มาส",
        "CY": "ประเทศไซปรัส",
        "CZ": "สาธารณรัฐเช็ก",
        "DE": "ประเทศเยอรมัน",
        "DJ": "จิบูตี",
        "DK": "เดนมาร์ก",
        "DM": "โดมินิกา",
        "DO": "สาธารณรัฐโดมินิกัน",
        "DZ": "แอลจีเรีย",
        "EC": "เอกวาดอร์",
        "EE": "เอสโตเนีย",
        "EG": "อียิปต์",
        "EH": "ซาฮาราตะวันตก",
        "ER": "เอริเทรี",
        "ES": "สเปน",
        "ET": "สาธารณรัฐเอธิโอเปีย",
        "FI": "ฟินแลนด์",
        "FJ": "ฟิจิ",
        "FK": "หมู่เกาะฟอล์คแลนด์",
        "FM": "ไมโครนีเซีย",
        "FO": "หมู่เกาะแฟโร",
        "FR": "ฝรั่งเศส",
        "GA": "ประเทศกาบอง",
        "GB": "อังกฤษ",
        "GD": "เกรเนดา",
        "GE": "จอร์เจีย",
        "GG": "เสื้อไหมพรม",
        "GH": "ประเทศกานา",
        "GI": "ยิบรอลตา",
        "GL": "เกาะกรีนแลนด์",
        "GM": "แกมเบีย",
        "GN": "ประเทศกินี",
        "GQ": "ทอเรียลกินี",
        "GR": "กรีก",
        "GT": "กัวเตมาลา",
        "GU": "กวม",
        "GW": "กินีบิสเซา",
        "GY": "กายอานา",
        "HK": "ฮ่องกง",
        "HN": "ฮอนดูรัส",
        "HR": "โครเอเชีย",
        "HT": "ไฮติ",
        "HU": "ฮังการี",
        "ID": "อินโดนีเซีย",
        "IE": "ไอร์แลนด์",
        "IL": "อิสราเอล",
        "IM": "เกาะ Isle of Man",
        "IN": "อินเดีย",
        "IO": "เขตมหาสมุทรบริติชอินเดีย",
        "IQ": "อิรัก",
        "IR": "อิหร่าน",
        "IS": "ประเทศไอซ์แลนด์",
        "IT": "อิตาลี",
        "JE": "รัฐนิวเจอร์ซีย์",
        "JM": "เกาะจาเมกา",
        "JO": "จอร์แดน",
        "JP": "ประเทศญี่ปุ่น",
        "KE": "ประเทศเคนย่า",
        "KG": "คีร์กีสถาน",
        "KH": "กัมพูชา",
        "KI": "ประเทศคิริบาส",
        "KM": "คอโมโรส",
        "KN": "เซนต์คิตส์และเนวิส",
        "KP": "เกาหลีเหนือ",
        "KR": "เกาหลี",
        "KW": "คูเวต",
        "KY": "หมู่เกาะเคย์เเมน",
        "KZ": "คาซัคสถาน",
        "LA": "ลาว",
        "LB": "เลบานอน",
        "LC": "เซนต์ลูเซีย",
        "LI": "นสไตน์",
        "LK": "ศรีลังกา",
        "LR": "ประเทศไลบีเรีย",
        "LS": "เลโซโท",
        "LT": "ประเทศลิธัวเนีย",
        "LU": "ลักเซมเบิร์ก",
        "LV": "ลัตเวีย",
        "LY": "ประเทศลิบยา",
        "MA": "โมร็อกโก",
        "MC": "โมนาโก",
        "MD": "มอลโดวา",
        "ME": "มอนเตเนโก",
        "MF": "San Martin",
        "MG": "มาดากัสการ์",
        "MH": "หมู่เกาะมาร์แชลล์",
        "MK": "มาซิโดเนีย",
        "ML": "มาลี",
        "MM": "พม่า",
        "MN": "ประเทศมองโกเลีย",
        "MO": "มาเก๊า",
        "MP": "หมู่เกาะมาเรียนาเหนือ",
        "MR": "ประเทศมอริเตเนีย",
        "MS": "มอนต์เซอร์รัต",
        "MT": "เกาะมอลตา",
        "MU": "มอริเชียส",
        "MV": "มัลดีฟส์",
        "MW": "มาลาวี",
        "MX": "เม็กซิโก",
        "MY": "ประเทศมาเลเซีย",
        "MZ": "ประเทศโมซัมบิก",
        "NA": "นามิเบีย",
        "NC": "New Caledonia",
        "NE": "ประเทศไนเธอร์",
        "NG": "ประเทศไนจีเรีย",
        "NI": "นิการากัว",
        "NL": "เนเธอร์แลนด์",
        "NO": "นอร์เวย์",
        "NP": "ประเทศเนปาล",
        "NR": "ประเทศนาอูรู",
        "NU": "นีอูเอ",
        "NZ": "นิวซีแลนด์",
        "OM": "โอมาน",
        "PA": "ปานามา",
        "PE": "เปรู",
        "PF": "french Polynesia",
        "PG": "ปาปัวนิวกินี",
        "PH": "ฟิลิปปินส์",
        "PK": "ประเทศปากีสถาน",
        "PL": "โปแลนด์",
        "PM": "เซนต์ปิแอร์และมีเกอลง",
        "PN": "พิตแคร์น",
        "PR": "เปอร์โตริโก",
        "PS": "ปาเลสไตน์",
        "PT": "โปรตุเกส",
        "PW": "ปาเลา",
        "PY": "ประเทศแพรากเว",
        "QA": "กาตาร์",
        "RE": "การรวมตัวใหม่",
        "RO": "โรมาเนีย",
        "RS": "เซอร์เบีย",
        "RU": "รัสเซีย",
        "RW": "รวันดา",
        "SA": "ประเทศซาอุดีอาระเบีย",
        "SB": "หมู่เกาะโซโลมอน",
        "SC": "เซเชลส์",
        "SD": "ซูดาน",
        "SE": "สวีเดน",
        "SG": "สิงคโปร์",
        "SH": "เซนต์เฮเลนา",
        "SI": "สโลวีเนีย",
        "SJ": "สวาลบาร์ด",
        "SK": "สโลวะเกีย",
        "SL": "เซียร์ราลีโอน",
        "SM": "ซานมารีโน",
        "SN": "ประเทศเซเนกัล",
        "SO": "โซมาเลีย",
        "SR": "ซูรินาเม",
        "SS": "ซูดานใต้",
        "ST": "Sao Tome Principe และ",
        "SV": "เอลซัลวาดอร์",
        "SX": "เซนต์มาติน",
        "SY": "ซีเรีย",
        "SZ": "สวาซิแลนด์",
        "TC": "เติกส์และหมู่เกาะไคคอส",
        "TD": "ชาด",
        "TG": "โตโก",
        "TH": "ประเทศไทย",
        "TJ": "ทาจิกิสถาน",
        "TK": "โตเกเลา",
        "TL": "ประเทศติมอร์ตะวันออก",
        "TM": "เติร์กเมนิสถาน",
        "TN": "ตูนิเซีย",
        "TO": "ตองกา",
        "TR": "ตุรกี",
        "TT": "ตรินิแดดและโตเบโก",
        "TV": "ตูวาลู",
        "TW": "ไต้หวัน",
        "TZ": "ประเทศแทนซาเนีย",
        "UA": "ยูเครน",
        "UG": "ยูกันดา",
        "US": "ประเทศสหรัฐอเมริกา",
        "UY": "อุรุกวัย",
        "UZ": "อุซเบกิ",
        "VA": "พระเห็น",
        "VC": "เซนต์วินเซนต์และเกรนาดีน",
        "VE": "เวเนซุเอลา",
        "VG": "หมู่เกาะบริติชเวอร์จิน",
        "VI": "หมู่เกาะเวอร์จินของสหรัฐอเมริกา",
        "VN": "เวียดนาม",
        "VU": "วานูอาตู",
        "WF": "วาลลิสและฟุตูนา",
        "WS": "ซามัว",
        "XK": "โคโซโว",
        "YE": "เยเมน",
        "YT": "มายอต",
        "ZA": "แอฟริกาใต้",
        "ZM": "ประเทศแซมเบีย",
        "ZW": "ประเทศซิมบับเว"
    },
    "trtr": {
        "AD": "Andorra",
        "AE": "Birleşik Arap Emirlikleri",
        "AF": "Afganistan",
        "AG": "Antigua ve Barbuda",
        "AI": "Anguilla",
        "AL": "Arnavutluk",
        "AM": "Ermenistan",
        "AN": "Hollanda Antilleri",
        "AO": "Angora",
        "AQ": "Antarktika",
        "AR": "Arjantin",
        "AS": "Samoa",
        "AT": "Avusturya",
        "AU": "Avustralya",
        "AW": "Aruba",
        "AZ": "Azerbeycan",
        "BA": "Bosna Hersek",
        "BB": "Barbados",
        "BD": "Bangladeş",
        "BE": "Belçika",
        "BF": "Burkina Faso",
        "BG": "Bulgaristan",
        "BH": "Bahreyn",
        "BI": "Burundi",
        "BJ": "benin",
        "BL": "Aziz Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivya",
        "BR": "Brezilya",
        "BS": "Bahamalar",
        "BT": "Butan",
        "BW": "Botsvana",
        "BY": "Beyaz rusya",
        "BZ": "Belize",
        "CA": "Kanada",
        "CC": "Cocos Adaları",
        "CD": "Demokratik Kongo Cumhuriyeti",
        "CF": "Orta Afrika Cumhuriyeti",
        "CG": "Demokratik Kongo Cumhuriyeti",
        "CH": "İsviçre",
        "CI": "Fildişi Sahili",
        "CK": "Cook Adaları",
        "CL": "Şili",
        "CM": "Kamerun",
        "CN": "Çin",
        "CO": "Kolombiya",
        "CR": "Kostarika",
        "CU": "Küba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Noel Adaları",
        "CY": "Kıbrıs",
        "CZ": "Çek Cumhuriyeti",
        "DE": "Almanya",
        "DJ": "Cibuti",
        "DK": "Danimarka",
        "DM": "Dominika",
        "DO": "Dominik Cumhuriyeti",
        "DZ": "Cezayir",
        "EC": "Ekvador",
        "EE": "Estonya",
        "EG": "Mısır",
        "EH": "Batı Sahra",
        "ER": "Eritre",
        "ES": "İspanya",
        "ET": "Etiyopya",
        "FI": "Finlandiya",
        "FJ": "Fiji",
        "FK": "Falkland Adaları",
        "FM": "Mikronezya",
        "FO": "Faroe Adaları",
        "FR": "Fransa",
        "GA": "Gabon",
        "GB": "İngilizce",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "bir tür inek",
        "GH": "Gana",
        "GI": "Cebelitarık",
        "GL": "Grönland",
        "GM": "Gambiya",
        "GN": "Gine",
        "GQ": "Ekvator Ginesi",
        "GR": "Yunanistan",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Gine-Bissau",
        "GY": "Guyana",
        "HK": "Hong Kong",
        "HN": "Honduras",
        "HR": "Hırvatistan",
        "HT": "Haiti",
        "HU": "Macaristan",
        "ID": "Endonezya",
        "IE": "İrlanda",
        "IL": "İsrail",
        "IM": "Isle of Man",
        "IN": "Hindistan",
        "IO": "İngiliz Hint Okyanusu Toprakları",
        "IQ": "Irak",
        "IR": "İran",
        "IS": "İzlanda",
        "IT": "İtalya",
        "JE": "New Jersey",
        "JM": "Jamaika",
        "JO": "Ürdün",
        "JP": "Japonya",
        "KE": "Kenya",
        "KG": "Kırgızistan",
        "KH": "Kamboçya",
        "KI": "Kiribati",
        "KM": "Komorlar",
        "KN": "Saint Kitts and Nevis",
        "KP": "Kuzey Kore",
        "KR": "Kore",
        "KW": "Kuveyt",
        "KY": "Cayman Adaları",
        "KZ": "kazakistan",
        "LA": "Laos",
        "LB": "Lübnan",
        "LC": "Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberya",
        "LS": "Lesotho",
        "LT": "Litvanya",
        "LU": "Lüksemburg",
        "LV": "Letonya",
        "LY": "Libya",
        "MA": "Fas",
        "MC": "Monako",
        "MD": "Moldova",
        "ME": "Karadağ",
        "MF": "San Martin",
        "MG": "Madagaskar",
        "MH": "Marshall Adaları",
        "MK": "Makedonya",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Moğolistan",
        "MO": "Macao",
        "MP": "Kuzey Mariana Adaları",
        "MR": "Moritanya",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldivler",
        "MW": "Malawi",
        "MX": "Meksika",
        "MY": "Malezya",
        "MZ": "Mozambik",
        "NA": "Namibya",
        "NC": "yeni Kaledonya",
        "NE": "Nijer",
        "NG": "Nijerya",
        "NI": "Nikaragua",
        "NL": "Hollanda",
        "NO": "Norveç",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "Yeni Zelanda",
        "OM": "Umman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "Fransız Polinezyası",
        "PG": "Papua Yeni Gine",
        "PH": "Filipinler",
        "PK": "Pakistan",
        "PL": "Polonya",
        "PM": "Aziz Pierre ve Miquelon",
        "PN": "Pitcairn",
        "PR": "Portoriko",
        "PS": "Filistin",
        "PT": "Portekiz",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Katar",
        "RE": "birleşme",
        "RO": "Romanya",
        "RS": "Sırbistan",
        "RU": "Rusya",
        "RW": "Ruanda",
        "SA": "Suudi Arabistan",
        "SB": "Solomon Adaları",
        "SC": "Seyşeller",
        "SD": "Sudan",
        "SE": "İsveç",
        "SG": "Singapur",
        "SH": "Helena",
        "SI": "Slovenya",
        "SJ": "Svalbard",
        "SK": "Slovakya",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somali",
        "SR": "Surinam",
        "SS": "Güney Sudan'ın",
        "ST": "Sao Tome ve Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Suriye",
        "SZ": "Svaziland",
        "TC": "Turks ve Caicos Adaları",
        "TD": "Çad",
        "TG": "Togo",
        "TH": "Tayland",
        "TJ": "Tacikistan",
        "TK": "Tokelau",
        "TL": "Doğu Timor",
        "TM": "Türkmenistan",
        "TN": "Tunus",
        "TO": "Tonga",
        "TR": "Türkiye",
        "TT": "Trinidad ve Tobago",
        "TV": "Tuvalu",
        "TW": "Tayvan",
        "TZ": "Tanzanya",
        "UA": "Ukrayna",
        "UG": "Uganda",
        "US": "Birleşik Devletler",
        "UY": "Uruguay",
        "UZ": "Özbekistan",
        "VA": "Holy See",
        "VC": "Saint Vincent ve Grenadines",
        "VE": "Venezuela",
        "VG": "İngiliz Virgin Adaları",
        "VI": "Amerika Birleşik Devletleri Virgin Adaları",
        "VN": "Vietnam",
        "VU": "Vanuatu",
        "WF": "Wallis ve Futuna",
        "WS": "Samoa",
        "XK": "Kosova",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "Güney Afrika",
        "ZM": "Zambiya",
        "ZW": "Zimbabve"
    },
    "vivn": {
        "AD": "Andorra",
        "AE": "Các Tiểu Vương Quốc Ả Rập Thống Nhất",
        "AF": "Afghanistan",
        "AG": "Antigua và Barbuda",
        "AI": "Anguilla",
        "AL": "Albania",
        "AM": "Armenia",
        "AN": "Antille thuộc Hà Lan",
        "AO": "Angola",
        "AQ": "Nam Cực",
        "AR": "Argentina",
        "AS": "American Samoa",
        "AT": "Áo",
        "AU": "Châu Úc",
        "AW": "Aruba",
        "AZ": "Azerbaijan",
        "BA": "Bosnia và Herzegovina",
        "BB": "Barbados",
        "BD": "Bangladesh",
        "BE": "Bỉ",
        "BF": "Burkina Faso",
        "BG": "Bulgaria",
        "BH": "Bahrain",
        "BI": "Burundi",
        "BJ": "Benin",
        "BL": "Saint Barthelemy",
        "BM": "Bermuda",
        "BN": "Brunei",
        "BO": "Bolivia",
        "BR": "Brazil",
        "BS": "Bahamas",
        "BT": "Bhutan",
        "BW": "Botswana",
        "BY": "Belarus",
        "BZ": "Belize",
        "CA": "Canada",
        "CC": "Quần đảo Cocos",
        "CD": "Cộng Hòa Dân Chủ Congo",
        "CF": "Cộng Hòa Trung Phi",
        "CG": "Cộng Hòa Congo",
        "CH": "Thụy sĩ",
        "CI": "Bờ Biển Ngà",
        "CK": "Quần đảo Cook",
        "CL": "Chile",
        "CM": "Cameroon",
        "CN": "Trung Quốc",
        "CO": "Colombia",
        "CR": "Costa Rica",
        "CU": "Cuba",
        "CV": "Cape Verde",
        "CW": "Curacao",
        "CX": "Christmas Islands",
        "CY": "Cyprus",
        "CZ": "Cộng Hòa Séc",
        "DE": "Đức",
        "DJ": "Djibouti",
        "DK": "Đan Mạch",
        "DM": "Dominica",
        "DO": "Cộng Hòa Dominica",
        "DZ": "Algeria",
        "EC": "Ecuador",
        "EE": "Estonia",
        "EG": "Ai Cập",
        "EH": "Tây Sahara",
        "ER": "Eritrea",
        "ES": "Tây Ban Nha",
        "ET": "Ethiopia",
        "FI": "Phần Lan",
        "FJ": "Fiji",
        "FK": "Quần đảo Falkland",
        "FM": "Micronesia",
        "FO": "Quần đảo Faroe",
        "FR": "Pháp",
        "GA": "Gabon",
        "GB": "Vương quốc Anh",
        "GD": "Grenada",
        "GE": "Georgia",
        "GG": "Guernsey",
        "GH": "Ghana",
        "GI": "Gibraltar",
        "GL": "Greenland",
        "GM": "Gambia",
        "GN": "Guinea",
        "GQ": "Equatorial Guinea",
        "GR": "Hy Lạp",
        "GT": "Guatemala",
        "GU": "Guam",
        "GW": "Guinea-Bissau",
        "GY": "Guyana",
        "HK": "Hồng Kông",
        "HN": "Honduras",
        "HR": "Croatia",
        "HT": "Haiti",
        "HU": "Hungary",
        "ID": "Indonesia",
        "IE": "Ireland",
        "IL": "Israel",
        "IM": "Isle of Man",
        "IN": "Ấn Độ",
        "IO": "Lãnh thổ Anh tại Ấn Độ Dương",
        "IQ": "Iraq",
        "IR": "Iran",
        "IS": "Iceland",
        "IT": "Ý",
        "JE": "Jersey",
        "JM": "Jamaica",
        "JO": "Jordan",
        "JP": "Nhật Bản",
        "KE": "Kenya",
        "KG": "Kyrgyzstan",
        "KH": "Campuchia",
        "KI": "Kiribati",
        "KM": "Comoros",
        "KN": "Saint Kitts và Nevis",
        "KP": "Bắc Triều Tiên",
        "KR": "Hàn Quốc",
        "KW": "Kuwait",
        "KY": "Quần đảo Cayman",
        "KZ": "Kazakhstan",
        "LA": "Lào",
        "LB": "Lebanon",
        "LC": "Saint Lucia",
        "LI": "Liechtenstein",
        "LK": "Sri Lanka",
        "LR": "Liberia",
        "LS": "Lesotho",
        "LT": "Lithuania",
        "LU": "Luxembourg",
        "LV": "Latvia",
        "LY": "Libya",
        "MA": "Morocco",
        "MC": "Monaco",
        "MD": "Moldova",
        "ME": "Montenegro",
        "MF": "Saint Martin",
        "MG": "Madagascar",
        "MH": "Đảo Marshall",
        "MK": "Macedonia",
        "ML": "Mali",
        "MM": "Myanmar",
        "MN": "Mông Cổ",
        "MO": "Macau",
        "MP": "Quần đảo Bắc Mariana",
        "MR": "Mauritania",
        "MS": "Montserrat",
        "MT": "Malta",
        "MU": "Mauritius",
        "MV": "Maldives",
        "MW": "Malawi",
        "MX": "Mexico",
        "MY": "Malaysia",
        "MZ": "Mozambique",
        "NA": "Namibia",
        "NC": "New Caledonia",
        "NE": "Niger",
        "NG": "Nigeria",
        "NI": "Nicaragua",
        "NL": "Hà Lan",
        "NO": "Na Uy",
        "NP": "Nepal",
        "NR": "Nauru",
        "NU": "Niue",
        "NZ": "New Zealand",
        "OM": "Oman",
        "PA": "Panama",
        "PE": "Peru",
        "PF": "French Polynesia",
        "PG": "Papua New Guinea",
        "PH": "Philippines",
        "PK": "Pakistan",
        "PL": "Ba Lan",
        "PM": "Saint Pierre và Miquelon",
        "PN": "Pitcairn",
        "PR": "Puerto Rico",
        "PS": "Palestine",
        "PT": "Bồ Đào Nha",
        "PW": "Palau",
        "PY": "Paraguay",
        "QA": "Qatar",
        "RE": "Reunion",
        "RO": "Romania",
        "RS": "Serbia",
        "RU": "Nga",
        "RW": "Rwanda",
        "SA": "Ả Rập Saudi",
        "SB": "Quần đảo Solomon",
        "SC": "Seychelles",
        "SD": "Sudan",
        "SE": "Thụy Điển",
        "SG": "Singapore",
        "SH": "Saint Helena",
        "SI": "Slovenia",
        "SJ": "Svalbard và Jan Mayen",
        "SK": "Slovakia",
        "SL": "Sierra Leone",
        "SM": "San Marino",
        "SN": "Senegal",
        "SO": "Somalia",
        "SR": "Suriname",
        "SS": "Nam Sudan",
        "ST": "Sao Tome và Principe",
        "SV": "El Salvador",
        "SX": "Sint Maarten",
        "SY": "Syria",
        "SZ": "Swaziland",
        "TC": "Quần đảo Turks và Caicos",
        "TD": "Chad",
        "TG": "Togo",
        "TH": "Thái Lan",
        "TJ": "Tajikistan",
        "TK": "Tokelau",
        "TL": "Đông Timor",
        "TM": "Turkmenistan",
        "TN": "Tunisia",
        "TO": "Tonga",
        "TR": "Turkey",
        "TT": "Trinidad và Tobago",
        "TV": "Tuvalu",
        "TW": "Đài Loan",
        "TZ": "Tanzania",
        "UA": "Ukraina",
        "UG": "Uganda",
        "US": "Hoa Kỳ",
        "UY": "Uruguay",
        "UZ": "Uzbekistan",
        "Up直播": "Uplive",
        "VA": "Vatican",
        "VC": "Saint Vincent và Grenadines",
        "VE": "Venezuela",
        "VG": "Quần đảo British Virgin",
        "VI": "Quần đảo Virgin Mỹ",
        "VN": "Việt Nam",
        "VU": "Vanuatu",
        "WF": "Wallis và Futuna",
        "WS": "Samoa",
        "XK": "Kosovo",
        "YE": "Yemen",
        "YT": "Mayotte",
        "ZA": "Nam Phi",
        "ZM": "Zambia",
        "ZW": "Zimbabwe",
        "主播可能在休息，稍后再来试试吧": "Host hiện đang nghỉ ngơi, thử lại sau nhé!",
        "余额不足情况下，充值提醒的描述": "Không đủ kim cương, nạp thêm nhé?",
        "你关注的人还没有直播": "Host bạn follow hiện không online",
        "充值 >": "Nạp tiền >",
        "关注": "Theo dõi",
        "分享失败": "Chia sẻ thất bại",
        "分享成功": "Chia sẻ thành công",
        "去看看当前热门直播": "Đến danh sách hot",
        "参数无效": "Thông số không hợp lệ",
        "发现": "Khám phá ",
        "发现新主播": "Khám phá thêm nhiều host mới nào",
        "发送": "Gửi",
        "取消": "Huỷ",
        "已取消分享": "Huỷ bỏ",
        "按语言推荐主播": "Đề nghị theo ngôn ngữ thích hợp",
        "搜索": "Tìm kiếm",
        "暂无数据": "Không có dữ liệu",
        "未知星球": "Không định vị được vị trí",
        "正在加载": "Loading",
        "没有更多数据了哦": "Đã hết",
        "热门": "Hot",
        "用户登录失效": "Đăng nhập thất bại",
        "登出": "Đăng xuất",
        "直播中": "Live",
        "确认": "Xác nhận",
        "系统错误": "Lỗi hệ thống",
        "经验值<%=num%>": "<%=num%> Exp",
        "获取个人信息失败": "Truy cập thông tin cá nhân thất bại",
        "获取成功": "Nhận thành công",
        "获取热门主播失败": "Không load được danh sách hot",
        "设置国家或地区失败": "Thiết lập quốc gia thất bại",
        "设置国家或地区成功": "Quốc gia được cập nhật",
        "说点什么吧": "Hãy nói gì đi nào",
        "请输入用户昵称或Up号": "Nhập nickname hoặc tên Uplive",
        "赠送": "Quà",
        "赠送了<%=giftName%>": "Đã gửi <%=giftName%>",
        "连": "+1",
        "选择国家或地区": "Chọn quốc gia của bạn",
        "重新选择": "Chọn lại"
    },
    "zhcn": {
        "<%=userName%>坐着<%=carName%>进入了直播间": "<%=userName%>坐着<%=carName%>进入了直播间",
        "AD": "安道尔",
        "AE": "阿拉伯联合酋长国",
        "AF": "阿富汗",
        "AG": "安提瓜和巴布达",
        "AI": "安圭拉",
        "AL": "阿尔巴尼亚",
        "AM": "亚美尼亚",
        "AN": "荷属安的列斯",
        "AO": "安哥拉",
        "AQ": "南极洲",
        "AR": "阿根廷",
        "AS": "美属萨摩亚",
        "AT": "奥地利",
        "AU": "澳大利亚",
        "AW": "阿鲁巴",
        "AZ": "阿塞拜疆",
        "BA": "波斯尼亚和黑塞哥维那",
        "BB": "巴巴多斯",
        "BD": "孟加拉国",
        "BE": "比利时",
        "BF": "布基纳法索",
        "BG": "保加利亚",
        "BH": "巴林",
        "BI": "布隆迪",
        "BJ": "贝宁",
        "BL": "圣巴泰勒米",
        "BM": "百慕大",
        "BN": "文莱",
        "BO": "玻利维亚",
        "BR": "巴西",
        "BS": "巴哈马",
        "BT": "不丹",
        "BW": "博茨瓦纳",
        "BY": "白俄罗斯",
        "BZ": "伯利兹",
        "CA": "加拿大",
        "CC": "科科斯群岛",
        "CD": "刚果民主共和国",
        "CF": "中非共和国",
        "CG": "刚果民主共和国",
        "CH": "瑞士",
        "CI": "象牙海岸",
        "CK": "库克群岛",
        "CL": "智利",
        "CM": "喀麦隆",
        "CN": "中国",
        "CO": "哥伦比亚",
        "CR": "哥斯达黎加",
        "CU": "古巴",
        "CV": "佛得角",
        "CW": "库拉索",
        "CX": "圣诞岛",
        "CY": "塞浦路斯",
        "CZ": "捷克共和国",
        "DE": "德国",
        "DJ": "吉布提",
        "DK": "丹麦",
        "DM": "多米尼加",
        "DO": "多明尼加共和国",
        "DZ": "阿尔及利亚",
        "EC": "厄瓜多尔",
        "EE": "爱沙尼亚",
        "EG": "埃及",
        "EH": "西撒哈拉",
        "ER": "厄立特里亚",
        "ES": "西班牙",
        "ET": "埃塞俄比亚",
        "FI": "芬兰",
        "FJ": "斐",
        "FK": "福克兰群岛",
        "FM": "密克罗尼西亚",
        "FO": "法罗群岛",
        "FR": "法国",
        "GA": "加蓬",
        "GB": "英国",
        "GD": "格林纳达",
        "GE": "格鲁吉亚",
        "GG": "根西岛",
        "GH": "加纳",
        "GI": "直布罗陀",
        "GL": "格陵兰",
        "GM": "冈比亚",
        "GN": "几内亚",
        "GQ": "赤道几内亚",
        "GR": "希腊",
        "GT": "危地马拉",
        "GU": "关岛",
        "GW": "几内亚比绍",
        "GY": "圭亚那",
        "HK": "香港",
        "HN": "洪都拉斯",
        "HR": "克罗地亚",
        "HT": "海地",
        "HU": "匈牙利",
        "ID": "印度尼西亚",
        "IE": "爱尔兰",
        "IL": "以色列",
        "IM": "马恩岛",
        "IN": "印度",
        "IO": "英属印度洋领地",
        "IQ": "伊拉克",
        "IR": "伊朗",
        "IS": "冰岛",
        "IT": "意大利",
        "JE": "新泽西",
        "JM": "牙买加",
        "JO": "约旦",
        "JP": "日本",
        "KE": "肯尼亚",
        "KG": "吉尔吉斯斯坦",
        "KH": "柬埔寨",
        "KI": "基里巴斯",
        "KM": "科摩罗",
        "KN": "圣基茨和尼维斯",
        "KP": "北朝鲜",
        "KR": "韩国",
        "KW": "科威特",
        "KY": "开曼群岛",
        "KZ": "哈萨克斯坦",
        "LA": "老挝",
        "LB": "黎巴嫩",
        "LC": "圣卢西亚",
        "LI": "列支敦士登",
        "LK": "斯里兰卡",
        "LR": "利比里亚",
        "LS": "莱索托",
        "LT": "立陶宛",
        "LU": "卢森堡",
        "LV": "拉脱维亚",
        "LY": "利比亚",
        "MA": "摩洛哥",
        "MC": "摩纳哥",
        "MD": "摩尔多瓦",
        "ME": "黑山",
        "MF": "圣马丁",
        "MG": "马达加斯加",
        "MH": "马绍尔群岛",
        "MK": "马其顿",
        "ML": "马里",
        "MM": "缅甸",
        "MN": "蒙古",
        "MO": "澳门",
        "MP": "北马里亚纳群岛",
        "MR": "毛里塔尼亚",
        "MS": "蒙特塞拉特",
        "MT": "马耳他",
        "MU": "毛里求斯",
        "MV": "马尔代夫",
        "MW": "马拉维",
        "MX": "墨西哥",
        "MY": "马来西亚",
        "MZ": "莫桑比克",
        "NA": "纳米比亚",
        "NC": "新喀里多尼亚",
        "NE": "尼日尔",
        "NG": "尼日利亚",
        "NI": "尼加拉瓜",
        "NL": "荷兰",
        "NO": "挪威",
        "NP": "尼泊尔",
        "NR": "瑙鲁",
        "NU": "纽埃",
        "NZ": "新西兰",
        "OM": "阿曼",
        "PA": "巴拿马",
        "PE": "秘鲁",
        "PF": "法属波利尼西亚",
        "PG": "巴布亚新几内亚",
        "PH": "菲律宾",
        "PK": "巴基斯坦",
        "PL": "波兰",
        "PM": "圣皮埃尔和密克隆",
        "PN": "皮特凯恩",
        "PR": "波多黎各",
        "PS": "巴勒斯坦",
        "PT": "葡萄牙",
        "PW": "帕劳",
        "PY": "巴拉圭",
        "QA": "卡塔尔",
        "RE": "团圆",
        "RO": "罗马尼亚",
        "RS": "塞尔维亚",
        "RU": "俄国",
        "RW": "卢旺达",
        "SA": "沙特阿拉伯",
        "SB": "所罗门群岛",
        "SC": "塞舌尔",
        "SD": "苏丹",
        "SE": "瑞典",
        "SG": "新加坡",
        "SH": "圣赫勒拿",
        "SI": "斯洛文尼亚",
        "SJ": "斯瓦尔巴特",
        "SK": "斯洛伐克",
        "SL": "塞拉利昂",
        "SM": "圣马力诺",
        "SN": "塞内加尔",
        "SO": "索马里",
        "SR": "苏里南",
        "SS": "南苏丹",
        "ST": "圣多美和普林西比",
        "SV": "萨尔瓦多",
        "SX": "圣马丁岛",
        "SY": "叙利亚",
        "SZ": "斯威士兰",
        "TC": "特克斯和凯科斯群岛",
        "TD": "乍得",
        "TG": "多哥",
        "TH": "泰国",
        "TJ": "塔吉克斯坦",
        "TK": "托克劳",
        "TL": "东帝汶",
        "TM": "土库曼斯坦",
        "TN": "突尼斯",
        "TO": "汤加",
        "TR": "土耳其",
        "TT": "特立尼达和多巴哥",
        "TV": "图瓦卢",
        "TW": "台湾",
        "TZ": "坦桑尼亚",
        "UA": "乌克兰",
        "UG": "乌干达",
        "US": "美国",
        "UY": "乌拉圭",
        "UZ": "乌兹别克斯坦",
        "Up号:<%=code%>": "Up号:<%=code%>",
        "Up直播": "Up直播",
        "U币贡献榜": "U币贡献榜",
        "VA": "教廷",
        "VC": "圣文森特和格林纳丁斯",
        "VE": "委内瑞拉",
        "VG": "英属维尔京群岛",
        "VI": "美属维尔京群岛",
        "VN": "越南",
        "VU": "瓦努阿图",
        "WF": "瓦利斯和富图纳群岛",
        "WS": "萨摩亚",
        "XK": "科索沃",
        "YE": "也门",
        "YT": "马约特",
        "ZA": "南非",
        "ZM": "赞比亚",
        "ZW": "津巴布韦",
        "个人信息设定失败": "个人信息设定失败",
        "个人信息设定成功": "个人信息设定成功",
        "主播可能在休息，稍后再来试试吧": "主播可能在休息，稍后再来试试吧",
        "主播已停播，即将返回首页!": "主播已停播，即将返回首页!",
        "优秀主播指南": "优秀主播指南",
        "余额不足情况下，充值提醒的描述": "余额不足, 是否前往充值?",
        "你关注的人还没有直播": "你关注的人还没有直播",
        "保存": "保存",
        "充值 >": "充值 >",
        "关注": "关注",
        "关注了主播，从此不再错过。": "关注了主播，从此不再错过。",
        "写个签名吧，让大家了解你。": "写个签名吧，让大家了解你。",
        "分享失败": "分享失败",
        "分享成功": "分享成功",
        "去看看当前热门直播": "去看看当前热门直播",
        "参数无效": "参数无效",
        "参数错误": "参数错误",
        "发现": "发现",
        "发现新主播": "发现新主播",
        "发送": "发送",
        "取消": "取消",
        "如何升级": "如何升级",
        "如何升级详情": "为优秀的主播送礼喝彩，送的越多升级越快。@@@@试试成为主播？优秀的主播升的更快。",
        "守护身价:<%=code%>": "守护身价:<%=code%>",
        "已停播": "已停播",
        "已关注": "已关注",
        "已取消分享": "已取消分享",
        "我的U钻": "我的U钻",
        "我的守护": "我的守护",
        "我的收益（U币）": "我的收益（U币）",
        "我的直播": "我的直播",
        "我的等级": "我的等级",
        "拉黑": "拉黑",
        "按语言推荐主播": "按语言推荐主播",
        "搜索": "搜索",
        "收到的U币": "收到的U币",
        "昵称不能出现敏感词": "昵称不能出现敏感词",
        "暂无数据": "暂无数据",
        "暂无被拉黑用户": "暂无被拉黑用户",
        "未知星球": "未知星球",
        "正在加载": "正在加载",
        "正在加载更多的数据...": "正在加载更多的数据...",
        "没发现此人，请重新输入试试": "没发现此人，请重新输入试试",
        "没有更多数据了哦": "没有更多数据了哦",
        "点亮了": "点亮了",
        "热门": "热门",
        "用户登录失效": "用户登录失效",
        "登出": "登出",
        "直播中": "直播中",
        "确认": "确认",
        "等级福利": "等级福利",
        "等级福利详情": " 高等级用户会有尊贵标识来凸显身份。@@@@ 等级越高，越有机会享受到定制化的产品福利。",
        "签名不能出现敏感词": "签名不能出现敏感词",
        "粉丝": "粉丝",
        "系统消息": "系统消息",
        "系统消息: 主播回来了，视频即将恢复！": "系统消息: 主播回来了，视频即将恢复！",
        "系统消息: 主播暂时离开了，小伙伴们请稍候。": "系统消息: 主播暂时离开了，小伙伴们请稍候。",
        "系统消息: 我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。": "系统消息: 我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。",
        "系统错误": "系统错误",
        "累计经验：<%=code%>": "累计经验：<%=code%>",
        "经验值<%=num%>": "经验值<%=num%>",
        "花费:": "花费:",
        "获取个人信息失败": "获取个人信息失败",
        "获取成功": "获取成功",
        "获取热门主播失败": "获取热门主播失败",
        "虚位以待": "虚位以待",
        "解除拉黑": "解除拉黑",
        "设置国家或地区失败": "设置国家或地区失败",
        "设置国家或地区成功": "设置国家或地区成功",
        "说点什么吧": "说点什么吧",
        "请竖屏获得更佳体验": "请竖屏获得更佳体验",
        "请输入用户昵称或Up号": "请输入用户昵称或Up号",
        "贡献U币:<%=code%>": "贡献U币:<%=code%>",
        "赠送": "赠送",
        "赠送了<%=count%>个<%=giftName%>": "赠送了<%=count%>个<%=giftName%>",
        "赠送了<%=giftName%>": "赠送了<%=giftName%>",
        "距离下一级：<%=code%>": "距离下一级：<%=code%>",
        "进入房间失败": "进入房间失败",
        "进入房间超时": "进入房间超时",
        "连": "连",
        "连接失败，请退出直播间重新进入": "连接失败，请退出直播间重新进入",
        "选择国家或地区": "选择国家或地区",
        "重新选择": "重新选择",
        "黑名单": "黑名单"
    },
    "zhhk": {
        "AD": "安道​​爾",
        "AE": "阿拉伯聯合酋長國",
        "AF": "阿富汗",
        "AG": "安提瓜和巴布達",
        "AI": "安圭拉",
        "AL": "阿爾巴尼亞",
        "AM": "亞美尼亞",
        "AN": "荷屬安的列斯",
        "AO": "安哥拉",
        "AQ": "南極洲",
        "AR": "阿根廷",
        "AS": "美屬薩摩亞",
        "AT": "奧地利",
        "AU": "澳大利亞",
        "AW": "阿魯巴",
        "AZ": "阿塞拜疆",
        "BA": "波斯尼亞和黑塞哥維那",
        "BB": "巴巴多斯",
        "BD": "孟加拉國",
        "BE": "比利時",
        "BF": "布基納法索",
        "BG": "保加利亞",
        "BH": "巴林",
        "BI": "布隆迪",
        "BJ": "貝寧",
        "BL": "聖巴泰勒米",
        "BM": "百慕大",
        "BN": "文萊",
        "BO": "玻利維亞",
        "BR": "巴西",
        "BS": "巴哈馬",
        "BT": "不丹",
        "BW": "博茨瓦納",
        "BY": "白俄羅斯",
        "BZ": "伯利茲",
        "CA": "加拿大",
        "CC": "科科斯群島",
        "CD": "剛果民主共和國",
        "CF": "中非共和國",
        "CG": "剛果民主共和國",
        "CH": "瑞士",
        "CI": "象牙海岸",
        "CK": "庫克群島",
        "CL": "智利",
        "CM": "喀麥隆",
        "CN": "中國",
        "CO": "哥倫比亞",
        "CR": "哥斯達黎加",
        "CU": "古巴",
        "CV": "佛得角",
        "CW": "庫拉索",
        "CX": "聖誕島",
        "CY": "塞浦路斯",
        "CZ": "捷克共和國",
        "DE": "德國",
        "DJ": "吉布提",
        "DK": "丹麥",
        "DM": "多米尼加",
        "DO": "多明尼加共和國",
        "DZ": "阿爾及利亞",
        "EC": "厄瓜多爾",
        "EE": "愛沙尼亞",
        "EG": "埃及",
        "EH": "西撒哈拉",
        "ER": "厄立特里亞",
        "ES": "西班牙",
        "ET": "埃塞俄比亞",
        "FI": "芬蘭",
        "FJ": "斐",
        "FK": "福克蘭群島",
        "FM": "密克羅尼西亞",
        "FO": "法羅群島",
        "FR": "法國",
        "GA": "加蓬",
        "GB": "英國",
        "GD": "格林納達",
        "GE": "格魯吉亞",
        "GG": "根西島",
        "GH": "加納",
        "GI": "直布羅陀",
        "GL": "格陵蘭",
        "GM": "岡比亞",
        "GN": "幾內亞",
        "GQ": "赤道幾內亞",
        "GR": "希臘",
        "GT": "危地馬拉",
        "GU": "關島",
        "GW": "幾內亞比紹",
        "GY": "圭亞那",
        "HK": "香港",
        "HN": "洪都拉斯",
        "HR": "克羅地亞",
        "HT": "海地",
        "HU": "匈牙利",
        "ID": "印度尼西亞",
        "IE": "愛爾蘭",
        "IL": "以色列",
        "IM": "馬恩島",
        "IN": "印度",
        "IO": "英屬印度洋領地",
        "IQ": "伊拉克",
        "IR": "伊朗",
        "IS": "冰島",
        "IT": "意大利",
        "JE": "新澤西",
        "JM": "牙買加",
        "JO": "約旦",
        "JP": "日本",
        "KE": "肯尼亞",
        "KG": "吉爾吉斯斯坦",
        "KH": "柬埔寨",
        "KI": "基里巴斯",
        "KM": "科摩羅",
        "KN": "聖基茨和尼維斯",
        "KP": "北朝鮮",
        "KR": "韓國",
        "KW": "科威特",
        "KY": "開曼群島",
        "KZ": "哈薩克斯坦",
        "LA": "老撾",
        "LB": "黎巴嫩",
        "LC": "聖盧西亞",
        "LI": "列支敦士登",
        "LK": "斯里蘭卡",
        "LR": "利比里亞",
        "LS": "萊索托",
        "LT": "立陶宛",
        "LU": "盧森堡",
        "LV": "拉脫維亞",
        "LY": "利比亞",
        "MA": "摩洛哥",
        "MC": "摩納哥",
        "MD": "摩爾多瓦",
        "ME": "黑山",
        "MF": "聖馬丁",
        "MG": "馬達加斯加",
        "MH": "馬紹爾群島",
        "MK": "馬其頓",
        "ML": "馬里",
        "MM": "緬甸",
        "MN": "蒙古",
        "MO": "澳門",
        "MP": "北馬里亞納群島",
        "MR": "毛里塔尼亞",
        "MS": "蒙特塞拉特",
        "MT": "馬耳他",
        "MU": "毛里求斯",
        "MV": "馬爾代夫",
        "MW": "馬拉維",
        "MX": "墨西哥",
        "MY": "馬來西亞",
        "MZ": "莫桑比克",
        "NA": "納米比亞",
        "NC": "新喀裡多尼亞",
        "NE": "尼日爾",
        "NG": "尼日利亞",
        "NI": "尼加拉瓜",
        "NL": "荷蘭",
        "NO": "挪威",
        "NP": "尼泊爾",
        "NR": "瑙魯",
        "NU": "紐埃",
        "NZ": "新西蘭",
        "OM": "阿曼",
        "PA": "巴拿馬",
        "PE": "秘魯",
        "PF": "法屬波利尼西亞",
        "PG": "巴布亞新幾內亞",
        "PH": "菲律賓",
        "PK": "巴基斯坦",
        "PL": "波蘭",
        "PM": "聖皮埃爾和密克隆",
        "PN": "皮特凱恩",
        "PR": "波多黎各",
        "PS": "巴勒斯坦",
        "PT": "葡萄牙",
        "PW": "帕勞",
        "PY": "巴拉圭",
        "QA": "卡塔爾",
        "RE": "團圓",
        "RO": "羅馬尼亞",
        "RS": "塞爾維亞",
        "RU": "俄國",
        "RW": "盧旺達",
        "SA": "沙特阿拉伯",
        "SB": "所羅門群島",
        "SC": "塞舌爾",
        "SD": "蘇丹",
        "SE": "瑞典",
        "SG": "新加坡",
        "SH": "聖赫勒拿",
        "SI": "斯洛文尼亞",
        "SJ": "斯瓦爾巴特",
        "SK": "斯洛伐克",
        "SL": "塞拉利昂",
        "SM": "聖馬力諾",
        "SN": "塞內加爾",
        "SO": "索馬里",
        "SR": "蘇里南",
        "SS": "南蘇丹",
        "ST": "聖多美和普林西比",
        "SV": "薩爾瓦多",
        "SX": "聖馬丁島",
        "SY": "敘利亞",
        "SZ": "斯威士蘭",
        "TC": "特克斯和凱科斯群島",
        "TD": "乍得",
        "TG": "多哥",
        "TH": "泰國",
        "TJ": "塔吉克斯坦",
        "TK": "托克勞",
        "TL": "東帝汶",
        "TM": "土庫曼斯坦",
        "TN": "突尼斯",
        "TO": "湯加",
        "TR": "土耳其",
        "TT": "特立尼達和多巴哥",
        "TV": "圖瓦盧",
        "TW": "台灣",
        "TZ": "坦桑尼亞",
        "UA": "烏克蘭",
        "UG": "烏干達",
        "US": "美國",
        "UY": "烏拉圭",
        "UZ": "烏茲別克斯坦",
        "VA": "教廷",
        "VC": "聖文森特和格林納丁斯",
        "VE": "委內瑞拉",
        "VG": "英屬維爾京群島",
        "VI": "美屬維爾京群島",
        "VN": "越南",
        "VU": "瓦努阿圖",
        "WF": "瓦利斯和富圖納群島",
        "WS": "薩摩亞",
        "XK": "科索沃",
        "YE": "也門",
        "YT": "馬約特",
        "ZA": "南非",
        "ZM": "贊比亞",
        "ZW": "津巴布韋"
    },
    "zhtw": {
        "<%=userName%>坐着<%=carName%>进入了直播间": "<%=userName%>坐著<%=carName%>進入了直播間",
        "AD": "安道​​爾",
        "AE": "阿拉伯聯合酋長國",
        "AF": "阿富汗",
        "AG": "安提瓜和巴布達",
        "AI": "安圭拉",
        "AL": "阿爾巴尼亞",
        "AM": "亞美尼亞",
        "AN": "荷屬安的列斯",
        "AO": "安哥拉",
        "AQ": "南極洲",
        "AR": "阿根廷",
        "AS": "美屬薩摩亞",
        "AT": "奧地利",
        "AU": "澳大利亞",
        "AW": "阿魯巴",
        "AZ": "阿塞拜疆",
        "BA": "波斯尼亞和黑塞哥維那",
        "BB": "巴巴多斯",
        "BD": "孟加拉國",
        "BE": "比利時",
        "BF": "布基納法索",
        "BG": "保加利亞",
        "BH": "巴林",
        "BI": "布隆迪",
        "BJ": "貝寧",
        "BL": "聖巴泰勒米",
        "BM": "百慕大",
        "BN": "文萊",
        "BO": "玻利維亞",
        "BR": "巴西",
        "BS": "巴哈馬",
        "BT": "不丹",
        "BW": "博茨瓦納",
        "BY": "白俄羅斯",
        "BZ": "伯利茲",
        "CA": "加拿大",
        "CC": "科科斯群島",
        "CD": "剛果民主共和國",
        "CF": "中非共和國",
        "CG": "剛果民主共和國",
        "CH": "瑞士",
        "CI": "象牙海岸",
        "CK": "庫克群島",
        "CL": "智利",
        "CM": "喀麥隆",
        "CN": "中國",
        "CO": "哥倫比亞",
        "CR": "哥斯達黎加",
        "CU": "古巴",
        "CV": "佛得角",
        "CW": "庫拉索",
        "CX": "聖誕島",
        "CY": "塞浦路斯",
        "CZ": "捷克共和國",
        "DE": "德國",
        "DJ": "吉布提",
        "DK": "丹麥",
        "DM": "多米尼加",
        "DO": "多明尼加共和國",
        "DZ": "阿爾及利亞",
        "EC": "厄瓜多爾",
        "EE": "愛沙尼亞",
        "EG": "埃及",
        "EH": "西撒哈拉",
        "ER": "厄立特里亞",
        "ES": "西班牙",
        "ET": "埃塞俄比亞",
        "FI": "芬蘭",
        "FJ": "斐",
        "FK": "福克蘭群島",
        "FM": "密克羅尼西亞",
        "FO": "法羅群島",
        "FR": "法國",
        "GA": "加蓬",
        "GB": "英國",
        "GD": "格林納達",
        "GE": "格魯吉亞",
        "GG": "根西島",
        "GH": "加納",
        "GI": "直布羅陀",
        "GL": "格陵蘭",
        "GM": "岡比亞",
        "GN": "幾內亞",
        "GQ": "赤道幾內亞",
        "GR": "希臘",
        "GT": "危地馬拉",
        "GU": "關島",
        "GW": "幾內亞比紹",
        "GY": "圭亞那",
        "HK": "香港",
        "HN": "洪都拉斯",
        "HR": "克羅地亞",
        "HT": "海地",
        "HU": "匈牙利",
        "ID": "印度尼西亞",
        "IE": "愛爾蘭",
        "IL": "以色列",
        "IM": "馬恩島",
        "IN": "印度",
        "IO": "英屬印度洋領地",
        "IQ": "伊拉克",
        "IR": "伊朗",
        "IS": "冰島",
        "IT": "意大利",
        "JE": "新澤西",
        "JM": "牙買加",
        "JO": "約旦",
        "JP": "日本",
        "KE": "肯尼亞",
        "KG": "吉爾吉斯斯坦",
        "KH": "柬埔寨",
        "KI": "基里巴斯",
        "KM": "科摩羅",
        "KN": "聖基茨和尼維斯",
        "KP": "北朝鮮",
        "KR": "韓國",
        "KW": "科威特",
        "KY": "開曼群島",
        "KZ": "哈薩克斯坦",
        "LA": "老撾",
        "LB": "黎巴嫩",
        "LC": "聖盧西亞",
        "LI": "列支敦士登",
        "LK": "斯里蘭卡",
        "LR": "利比里亞",
        "LS": "萊索托",
        "LT": "立陶宛",
        "LU": "盧森堡",
        "LV": "拉脫維亞",
        "LY": "利比亞",
        "MA": "摩洛哥",
        "MC": "摩納哥",
        "MD": "摩爾多瓦",
        "ME": "黑山",
        "MF": "聖馬丁",
        "MG": "馬達加斯加",
        "MH": "馬紹爾群島",
        "MK": "馬其頓",
        "ML": "馬里",
        "MM": "緬甸",
        "MN": "蒙古",
        "MO": "澳門",
        "MP": "北馬里亞納群島",
        "MR": "毛里塔尼亞",
        "MS": "蒙特塞拉特",
        "MT": "馬耳他",
        "MU": "毛里求斯",
        "MV": "馬爾代夫",
        "MW": "馬拉維",
        "MX": "墨西哥",
        "MY": "馬來西亞",
        "MZ": "莫桑比克",
        "NA": "納米比亞",
        "NC": "新喀裡多尼亞",
        "NE": "尼日爾",
        "NG": "尼日利亞",
        "NI": "尼加拉瓜",
        "NL": "荷蘭",
        "NO": "挪威",
        "NP": "尼泊爾",
        "NR": "瑙魯",
        "NU": "紐埃",
        "NZ": "新西蘭",
        "OM": "阿曼",
        "PA": "巴拿馬",
        "PE": "秘魯",
        "PF": "法屬波利尼西亞",
        "PG": "巴布亞新幾內亞",
        "PH": "菲律賓",
        "PK": "巴基斯坦",
        "PL": "波蘭",
        "PM": "聖皮埃爾和密克隆",
        "PN": "皮特凱恩",
        "PR": "波多黎各",
        "PS": "巴勒斯坦",
        "PT": "葡萄牙",
        "PW": "帕勞",
        "PY": "巴拉圭",
        "QA": "卡塔爾",
        "RE": "團圓",
        "RO": "羅馬尼亞",
        "RS": "塞爾維亞",
        "RU": "俄國",
        "RW": "盧旺達",
        "SA": "沙特阿拉伯",
        "SB": "所羅門群島",
        "SC": "塞舌爾",
        "SD": "蘇丹",
        "SE": "瑞典",
        "SG": "新加坡",
        "SH": "聖赫勒拿",
        "SI": "斯洛文尼亞",
        "SJ": "斯瓦爾巴特",
        "SK": "斯洛伐克",
        "SL": "塞拉利昂",
        "SM": "聖馬力諾",
        "SN": "塞內加爾",
        "SO": "索馬里",
        "SR": "蘇里南",
        "SS": "南蘇丹",
        "ST": "聖多美和普林西比",
        "SV": "薩爾瓦多",
        "SX": "聖馬丁島",
        "SY": "敘利亞",
        "SZ": "斯威士蘭",
        "TC": "特克斯和凱科斯群島",
        "TD": "乍得",
        "TG": "多哥",
        "TH": "泰國",
        "TJ": "塔吉克斯坦",
        "TK": "托克勞",
        "TL": "東帝汶",
        "TM": "土庫曼斯坦",
        "TN": "突尼斯",
        "TO": "湯加",
        "TR": "土耳其",
        "TT": "特立尼達和多巴哥",
        "TV": "圖瓦盧",
        "TW": "台灣",
        "TZ": "坦桑尼亞",
        "UA": "烏克蘭",
        "UG": "烏干達",
        "US": "美國",
        "UY": "烏拉圭",
        "UZ": "烏茲別克斯坦",
        "Up号:<%=code%>": "Up帳號：<%=code%>",
        "Up直播": "Up直播",
        "U币贡献榜": "U幣貢獻榜",
        "VA": "教廷",
        "VC": "聖文森特和格林納丁斯",
        "VE": "委內瑞拉",
        "VG": "英屬維爾京群島",
        "VI": "美屬維爾京群島",
        "VN": "越南",
        "VU": "瓦努阿圖",
        "WF": "瓦利斯和富圖納群島",
        "WS": "薩摩亞",
        "XK": "科索沃",
        "YE": "也門",
        "YT": "馬約特",
        "ZA": "南非",
        "ZM": "贊比亞",
        "ZW": "津巴布韋",
        "个人信息设定失败": "個人檔案設定失敗",
        "个人信息设定成功": "個人檔案設定成功",
        "主播可能在休息，稍后再来试试吧": "主播可能在休息，等等再來試試吧",
        "主播已停播，即将返回首页!": "主播已關播，即將返回首頁！",
        "优秀主播指南": "優秀主播指南",
        "余额不足情况下，充值提醒的描述": "餘額不足，是否前往儲值？",
        "你关注的人还没有直播": "你追蹤的人還沒直播",
        "保存": "保存",
        "充值 >": "儲值 >",
        "关注": "追蹤",
        "关注了主播，从此不再错过。": "追蹤了主播，從此不再錯過。",
        "写个签名吧，让大家了解你。": "寫個簽名檔，讓大家更了解你！",
        "分享失败": "分享失敗",
        "分享成功": "分享成功",
        "去看看当前热门直播": "去看看現在正夯直播",
        "参数无效": "參數無效",
        "参数错误": "參數錯誤",
        "发现": "發現",
        "发现新主播": "發現新主播",
        "发送": "傳送",
        "取消": "取消",
        "如何升级": "如何升級",
        "如何升级详情": "給主播送送禮物，送的越多升級的越快。@@@@試試成為主播，更有機會升級呦~",
        "守护身价:<%=code%>": "守護身價：<%=code%>",
        "已停播": "已停播",
        "已关注": "已追蹤",
        "已取消分享": "已取消分享",
        "我的U钻": "我的U鑽",
        "我的守护": "我的守護",
        "我的收益（U币）": "我的收益 (U幣)",
        "我的直播": "我的直播",
        "我的等级": "我的等級",
        "拉黑": "加入黑名單",
        "按语言推荐主播": "依照語言推薦主播",
        "搜索": "搜尋",
        "收到的U币": "收到的U幣",
        "昵称不能出现敏感词": "暱稱不能出現敏感詞",
        "暂无数据": "暫無資料",
        "暂无被拉黑用户": "暫無黑名單用戶",
        "未知星球": "未知位置",
        "正在加载": "正在載入",
        "正在加载更多的数据...": "正在載入更多的資料....",
        "没发现此人，请重新输入试试": "未找您想找的人，請重新輸入",
        "没有更多数据了哦": "沒有更多資料了哦",
        "点亮了": "已戀愛",
        "热门": "正夯",
        "用户登录失效": "用戶登入失敗",
        "登出": "登出",
        "直播中": "直播中",
        "确认": "確定",
        "等级福利": "等級福利",
        "等级福利详情": "等級高用戶會有尊貴標示來凸顯身份。@@@@等級越高，越有機會享受福利。",
        "签名不能出现敏感词": "簽名檔不能出現敏感詞",
        "粉丝": "粉絲",
        "系统消息": "系統消息",
        "系统消息: 主播回来了，视频即将恢复！": "系統消息：主播回來了",
        "系统消息: 主播暂时离开了，小伙伴们请稍候。": "系統消息：主播暫時離開，請耐心等待。",
        "系统消息: 我们提倡绿色直播，只有通过审核并被标记为优质的主播才可能出现在热门，如封面和直播内容含有涉黄、低俗、吸烟、暴露等情况，将会被封禁账号。网警将保持24小时在线审核与审查，请您遵守。": "系統消息：我們提倡綠色直播，只有通過審核並被註記為優質主播才有可能出現在熱門列表，如封面和直播內容含有情色、吸菸或其它不雅的情況，將會被封鎖帳號，管理員24小時線上巡邏，請您務必遵守。",
        "系统错误": "系統錯誤",
        "累计经验：<%=code%>": "累計經驗：<%=code%>",
        "经验值<%=num%>": "經驗值<%=num%>",
        "花费:": "花費：",
        "获取个人信息失败": "獲取個人檔案失敗",
        "获取成功": "獲取成功",
        "获取热门主播失败": "獲取正夯主播失敗",
        "虚位以待": "虛位以待",
        "解除拉黑": "解除黑名單",
        "设置国家或地区失败": "設置國家或地區失敗",
        "设置国家或地区成功": "設置國家或地區成功",
        "说点什么吧": "說點話吧",
        "请竖屏获得更佳体验": "請豎屏獲得最好體驗",
        "请输入用户昵称或Up号": "請輸入用戶暱稱或Up帳號",
        "贡献U币:<%=code%>": "貢獻U幣：<%=code%>",
        "赠送": "贈送",
        "赠送了<%=count%>个<%=giftName%>": "贈送了<%=count%>個<%=giftName%>",
        "赠送了<%=giftName%>": "贈送了<%=giftName%>",
        "距离下一级：<%=code%>": "距離下一級：<%=code%>",
        "进入房间失败": "進入直播間失敗",
        "进入房间超时": "進入直播間超時",
        "连": "連",
        "连接失败，请退出直播间重新进入": "連接失敗，請退出直播間重新進入",
        "选择国家或地区": "選擇國家或地區",
        "重新选择": "重新選擇",
        "黑名单": "黑名單"
    }
}


// WEBPACK FOOTER //
// ./js/lang/pack.js